//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ICartClient {
    /**
     * @return OK
     */
    getCart(userId: number): Observable<Cart>;
    /**
     * @param body (optional) 
     * @return OK
     */
    cart(body: Cart | undefined): Observable<Cart>;
    /**
     * @return OK
     */
    getCartCount(userId: number): Observable<number>;
    /**
     * @return OK
     */
    deleteCartSeat(seatId: number, webinarId: number, cartId: number): Observable<boolean>;
    /**
     * @return OK
     */
    deleteCartItemWithAllSeats(webinarId: number, cartId: number): Observable<boolean>;
    /**
     * @return OK
     */
    deleteAllCartItemsByUserId(userId: number): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    cartCheckoutWithCardPayment(body: OrderDTO | undefined): Observable<CartCheckoutResponseDTO>;
    /**
     * @return OK
     */
    purchaseFreeBeeWebinars(userId: number): Observable<CartCheckoutResponseDTO>;
}

@Injectable()
export class CartClient implements ICartClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCart(userId: number): Observable<Cart> {
        let url_ = this.baseUrl + "/api/Cart/GetCart/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Cart>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Cart>;
        }));
    }

    protected processGetCart(response: HttpResponseBase): Observable<Cart> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Cart.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Cart>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cart(body: Cart | undefined): Observable<Cart> {
        let url_ = this.baseUrl + "/api/Cart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Cart>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Cart>;
        }));
    }

    protected processCart(response: HttpResponseBase): Observable<Cart> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Cart.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Cart>(null as any);
    }

    /**
     * @return OK
     */
    getCartCount(userId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Cart/GetCartCount/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCartCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCartCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCartCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    deleteCartSeat(seatId: number, webinarId: number, cartId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Cart/DeleteCartSeat/{seatId}/{webinarId}/{cartId}";
        if (seatId === undefined || seatId === null)
            throw new Error("The parameter 'seatId' must be defined.");
        url_ = url_.replace("{seatId}", encodeURIComponent("" + seatId));
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        if (cartId === undefined || cartId === null)
            throw new Error("The parameter 'cartId' must be defined.");
        url_ = url_.replace("{cartId}", encodeURIComponent("" + cartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCartSeat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCartSeat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCartSeat(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteCartItemWithAllSeats(webinarId: number, cartId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Cart/DeleteCartItemWithAllSeats/{webinarId}/{cartId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        if (cartId === undefined || cartId === null)
            throw new Error("The parameter 'cartId' must be defined.");
        url_ = url_.replace("{cartId}", encodeURIComponent("" + cartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCartItemWithAllSeats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCartItemWithAllSeats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCartItemWithAllSeats(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteAllCartItemsByUserId(userId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Cart/DeleteAllCartItemsByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllCartItemsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllCartItemsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAllCartItemsByUserId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cartCheckoutWithCardPayment(body: OrderDTO | undefined): Observable<CartCheckoutResponseDTO> {
        let url_ = this.baseUrl + "/api/Cart/CartCheckoutWithCardPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCartCheckoutWithCardPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCartCheckoutWithCardPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartCheckoutResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartCheckoutResponseDTO>;
        }));
    }

    protected processCartCheckoutWithCardPayment(response: HttpResponseBase): Observable<CartCheckoutResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartCheckoutResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartCheckoutResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    purchaseFreeBeeWebinars(userId: number): Observable<CartCheckoutResponseDTO> {
        let url_ = this.baseUrl + "/api/Cart/PurchaseFreeBeeWebinars/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseFreeBeeWebinars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseFreeBeeWebinars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartCheckoutResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartCheckoutResponseDTO>;
        }));
    }

    protected processPurchaseFreeBeeWebinars(response: HttpResponseBase): Observable<CartCheckoutResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartCheckoutResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartCheckoutResponseDTO>(null as any);
    }
}

export interface IContactUsClient {
    /**
     * @return OK
     */
    getInquiryTypes(): Observable<InquiryType[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createInquiry(body: Inquiry | undefined): Observable<Inquiry>;
}

@Injectable()
export class ContactUsClient implements IContactUsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getInquiryTypes(): Observable<InquiryType[]> {
        let url_ = this.baseUrl + "/api/ContactUs/GetInquiryTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInquiryTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInquiryTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InquiryType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InquiryType[]>;
        }));
    }

    protected processGetInquiryTypes(response: HttpResponseBase): Observable<InquiryType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InquiryType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InquiryType[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInquiry(body: Inquiry | undefined): Observable<Inquiry> {
        let url_ = this.baseUrl + "/api/ContactUs/CreateInquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Inquiry>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Inquiry>;
        }));
    }

    protected processCreateInquiry(response: HttpResponseBase): Observable<Inquiry> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Inquiry.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Inquiry>(null as any);
    }
}

export interface IFacebookClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    pages(body: string | undefined): Observable<string>;
    /**
     * @param pageId (optional) 
     * @param pageAccessToken (optional) 
     * @param caption (optional) 
     * @param image (optional) 
     * @return OK
     */
    postWebinar(pageId: string | undefined, pageAccessToken: string | undefined, caption: string | undefined, image: FileParameter | undefined): Observable<boolean>;
}

@Injectable()
export class FacebookClient implements IFacebookClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pages(body: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Facebook/pages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPages(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param pageId (optional) 
     * @param pageAccessToken (optional) 
     * @param caption (optional) 
     * @param image (optional) 
     * @return OK
     */
    postWebinar(pageId: string | undefined, pageAccessToken: string | undefined, caption: string | undefined, image: FileParameter | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Facebook/post-webinar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pageId === null || pageId === undefined)
            throw new Error("The parameter 'pageId' cannot be null.");
        else
            content_.append("PageId", pageId.toString());
        if (pageAccessToken === null || pageAccessToken === undefined)
            throw new Error("The parameter 'pageAccessToken' cannot be null.");
        else
            content_.append("PageAccessToken", pageAccessToken.toString());
        if (caption === null || caption === undefined)
            throw new Error("The parameter 'caption' cannot be null.");
        else
            content_.append("Caption", caption.toString());
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostWebinar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostWebinar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPostWebinar(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IFaqClient {
    /**
     * @return OK
     */
    getFaqs(): Observable<Faq[]>;
}

@Injectable()
export class FaqClient implements IFaqClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getFaqs(): Observable<Faq[]> {
        let url_ = this.baseUrl + "/api/Faq/GetFaqs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaqs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaqs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Faq[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Faq[]>;
        }));
    }

    protected processGetFaqs(response: HttpResponseBase): Observable<Faq[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Faq.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Faq[]>(null as any);
    }
}

export interface IHostPortalClient {
    /**
     * @param roomId (optional) 
     * @return OK
     */
    webinarQueues(roomId: number | undefined): Observable<WebinarQueueDTO[]>;
    /**
     * @param roomId (optional) 
     * @return OK
     */
    userConfiguration(roomId: number | undefined): Observable<WebinarRoomConfiguration[]>;
    /**
     * @return OK
     */
    roomBussinessImage(roomId: number): Observable<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveConfiguration(body: WebinarRoomConfiguration[] | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveOutOfOffice(body: OutOfOffice[] | undefined): Observable<boolean>;
    /**
     * @param userId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getOutOfOffice(userId: number | undefined, filter: boolean | undefined): Observable<OutOfOffice[]>;
    /**
     * @return OK
     */
    getTimeSlots(): Observable<TimeSlot[]>;
    /**
     * @param userId (optional) 
     * @param webinarRoomId (optional) 
     * @return OK
     */
    getMyStats(userId: number | undefined, webinarRoomId: number | undefined): Observable<MyStats[]>;
    /**
     * @return OK
     */
    getShippingOptions(): Observable<ShippingOption[]>;
    /**
     * @param webinarRoomId (optional) 
     * @return OK
     */
    getMyShipments(webinarRoomId: number | undefined): Observable<MyShipmentsDTO>;
    /**
     * @return OK
     */
    getMyShipmentsByDates(startDate: Date, endDate: Date, webinarRoomId: number): Observable<MyShipmentsDTO>;
    /**
     * @param webinarShippingId (optional) 
     * @param shippinhOptionId (optional) 
     * @return OK
     */
    updateShippingOption(webinarShippingId: number | undefined, shippinhOptionId: number | undefined): Observable<boolean>;
    /**
     * @param webinarShippingId (optional) 
     * @return OK
     */
    notifyUser(webinarShippingId: number | undefined): Observable<boolean>;
    /**
     * @param webinarShippingId (optional) 
     * @param trackingId (optional) 
     * @return OK
     */
    updateTrackingId(webinarShippingId: number | undefined, trackingId: string | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateShipment(body: ShipmentUpdateDTO | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getHistoricalData(body: HistoricalSalesInputDTO | undefined): Observable<HistoricalSalesDTO[]>;
    /**
     * @return OK
     */
    getStatuses(): Observable<WebinarRunningStatus[]>;
    /**
     * Emails the rewatch link to the intersection of the requested recipients and this webinar's actual seat purchasers.
     * @param body (optional)
     * @return OK
     */
    shareWebinarRecording(hostUserId: number, body: ShareWebinarRecordingRequest | undefined): Observable<number>;
    /**
     * @return OK
     */
    getShareHistory(webinarId: number): Observable<WebinarVideoShareDTO[]>;
    /**
     * @param webinarShipmentId (optional)
     * @param body (optional) 
     * @return OK
     */
    createUSPSLabel(webinarShipmentId: number | undefined, body: USPSLabelRequest | undefined): Observable<USPSLabelResponse>;
    /**
     * @param webinarShipmentId (optional) 
     * @param body (optional) 
     * @return OK
     */
    getUSPSPrice(webinarShipmentId: number | undefined, body: USPSLabelRequest | undefined): Observable<USPSPriceResponse>;
    /**
     * @param webinarRoomId (optional) 
     * @return OK
     */
    getSavedFromAddress(webinarRoomId: number | undefined): Observable<WebinarRoomOwnerFromAddress>;
}

@Injectable()
export class HostPortalClient implements IHostPortalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param roomId (optional) 
     * @return OK
     */
    webinarQueues(roomId: number | undefined): Observable<WebinarQueueDTO[]> {
        let url_ = this.baseUrl + "/WebinarQueues?";
        if (roomId === null)
            throw new Error("The parameter 'roomId' cannot be null.");
        else if (roomId !== undefined)
            url_ += "roomId=" + encodeURIComponent("" + roomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebinarQueues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebinarQueues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarQueueDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarQueueDTO[]>;
        }));
    }

    protected processWebinarQueues(response: HttpResponseBase): Observable<WebinarQueueDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarQueueDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarQueueDTO[]>(null as any);
    }

    /**
     * @param roomId (optional) 
     * @return OK
     */
    userConfiguration(roomId: number | undefined): Observable<WebinarRoomConfiguration[]> {
        let url_ = this.baseUrl + "/UserConfiguration?";
        if (roomId === null)
            throw new Error("The parameter 'roomId' cannot be null.");
        else if (roomId !== undefined)
            url_ += "roomId=" + encodeURIComponent("" + roomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarRoomConfiguration[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarRoomConfiguration[]>;
        }));
    }

    protected processUserConfiguration(response: HttpResponseBase): Observable<WebinarRoomConfiguration[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarRoomConfiguration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarRoomConfiguration[]>(null as any);
    }

    /**
     * @return OK
     */
    roomBussinessImage(roomId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/HostPortal/RoomBussinessImage/{roomId}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoomBussinessImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoomBussinessImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRoomBussinessImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveConfiguration(body: WebinarRoomConfiguration[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/SaveConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveConfiguration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveOutOfOffice(body: OutOfOffice[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/SaveOutOfOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveOutOfOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveOutOfOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveOutOfOffice(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getOutOfOffice(userId: number | undefined, filter: boolean | undefined): Observable<OutOfOffice[]> {
        let url_ = this.baseUrl + "/GetOutOfOffice?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutOfOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutOfOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutOfOffice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutOfOffice[]>;
        }));
    }

    protected processGetOutOfOffice(response: HttpResponseBase): Observable<OutOfOffice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutOfOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutOfOffice[]>(null as any);
    }

    /**
     * @return OK
     */
    getTimeSlots(): Observable<TimeSlot[]> {
        let url_ = this.baseUrl + "/GetTimeSlots";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeSlot[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeSlot[]>;
        }));
    }

    protected processGetTimeSlots(response: HttpResponseBase): Observable<TimeSlot[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeSlot.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeSlot[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param webinarRoomId (optional) 
     * @return OK
     */
    getMyStats(userId: number | undefined, webinarRoomId: number | undefined): Observable<MyStats[]> {
        let url_ = this.baseUrl + "/GetMyStats?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (webinarRoomId === null)
            throw new Error("The parameter 'webinarRoomId' cannot be null.");
        else if (webinarRoomId !== undefined)
            url_ += "webinarRoomId=" + encodeURIComponent("" + webinarRoomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyStats[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyStats[]>;
        }));
    }

    protected processGetMyStats(response: HttpResponseBase): Observable<MyStats[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyStats.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MyStats[]>(null as any);
    }

    /**
     * @return OK
     */
    getShippingOptions(): Observable<ShippingOption[]> {
        let url_ = this.baseUrl + "/GetShippingOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingOption[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingOption[]>;
        }));
    }

    protected processGetShippingOptions(response: HttpResponseBase): Observable<ShippingOption[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShippingOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingOption[]>(null as any);
    }

    /**
     * @param webinarRoomId (optional) 
     * @return OK
     */
    getMyShipments(webinarRoomId: number | undefined): Observable<MyShipmentsDTO> {
        let url_ = this.baseUrl + "/GetMyShipments?";
        if (webinarRoomId === null)
            throw new Error("The parameter 'webinarRoomId' cannot be null.");
        else if (webinarRoomId !== undefined)
            url_ += "webinarRoomId=" + encodeURIComponent("" + webinarRoomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyShipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyShipmentsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyShipmentsDTO>;
        }));
    }

    protected processGetMyShipments(response: HttpResponseBase): Observable<MyShipmentsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyShipmentsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MyShipmentsDTO>(null as any);
    }

    /**
     * @return OK
     */
    getMyShipmentsByDates(startDate: Date, endDate: Date, webinarRoomId: number): Observable<MyShipmentsDTO> {
        let url_ = this.baseUrl + "/GetMyShipmentsByDates/{startDate}/{endDate}/{webinarRoomId}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        if (webinarRoomId === undefined || webinarRoomId === null)
            throw new Error("The parameter 'webinarRoomId' must be defined.");
        url_ = url_.replace("{webinarRoomId}", encodeURIComponent("" + webinarRoomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyShipmentsByDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyShipmentsByDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyShipmentsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyShipmentsDTO>;
        }));
    }

    protected processGetMyShipmentsByDates(response: HttpResponseBase): Observable<MyShipmentsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyShipmentsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MyShipmentsDTO>(null as any);
    }

    /**
     * @param webinarShippingId (optional) 
     * @param shippinhOptionId (optional) 
     * @return OK
     */
    updateShippingOption(webinarShippingId: number | undefined, shippinhOptionId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/UpdateShippingOption?";
        if (webinarShippingId === null)
            throw new Error("The parameter 'webinarShippingId' cannot be null.");
        else if (webinarShippingId !== undefined)
            url_ += "webinarShippingId=" + encodeURIComponent("" + webinarShippingId) + "&";
        if (shippinhOptionId === null)
            throw new Error("The parameter 'shippinhOptionId' cannot be null.");
        else if (shippinhOptionId !== undefined)
            url_ += "shippinhOptionId=" + encodeURIComponent("" + shippinhOptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShippingOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShippingOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateShippingOption(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param webinarShippingId (optional) 
     * @return OK
     */
    notifyUser(webinarShippingId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/NotifyUser?";
        if (webinarShippingId === null)
            throw new Error("The parameter 'webinarShippingId' cannot be null.");
        else if (webinarShippingId !== undefined)
            url_ += "webinarShippingId=" + encodeURIComponent("" + webinarShippingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processNotifyUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param webinarShippingId (optional) 
     * @param trackingId (optional) 
     * @return OK
     */
    updateTrackingId(webinarShippingId: number | undefined, trackingId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/UpdateTrackingId?";
        if (webinarShippingId === null)
            throw new Error("The parameter 'webinarShippingId' cannot be null.");
        else if (webinarShippingId !== undefined)
            url_ += "webinarShippingId=" + encodeURIComponent("" + webinarShippingId) + "&";
        if (trackingId === null)
            throw new Error("The parameter 'trackingId' cannot be null.");
        else if (trackingId !== undefined)
            url_ += "trackingId=" + encodeURIComponent("" + trackingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTrackingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTrackingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTrackingId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateShipment(body: ShipmentUpdateDTO | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/UpdateShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateShipment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getHistoricalData(body: HistoricalSalesInputDTO | undefined): Observable<HistoricalSalesDTO[]> {
        let url_ = this.baseUrl + "/GetHistoricalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricalSalesDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricalSalesDTO[]>;
        }));
    }

    protected processGetHistoricalData(response: HttpResponseBase): Observable<HistoricalSalesDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoricalSalesDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HistoricalSalesDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getStatuses(): Observable<WebinarRunningStatus[]> {
        let url_ = this.baseUrl + "/GetStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarRunningStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarRunningStatus[]>;
        }));
    }

    protected processGetStatuses(response: HttpResponseBase): Observable<WebinarRunningStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarRunningStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarRunningStatus[]>(null as any);
    }

    /**
     * Emails the rewatch link to the intersection of the requested recipients and this webinar's actual seat purchasers.
     * @param body (optional)
     * @return OK
     */
    shareWebinarRecording(hostUserId: number, body: ShareWebinarRecordingRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/ShareWebinarRecording?";
        if (hostUserId === undefined || hostUserId === null)
            throw new Error("The parameter 'hostUserId' must be defined.");
        else
            url_ += "hostUserId=" + encodeURIComponent("" + hostUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShareWebinarRecording(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShareWebinarRecording(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processShareWebinarRecording(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getShareHistory(webinarId: number): Observable<WebinarVideoShareDTO[]> {
        let url_ = this.baseUrl + "/GetShareHistory/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShareHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShareHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarVideoShareDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarVideoShareDTO[]>;
        }));
    }

    protected processGetShareHistory(response: HttpResponseBase): Observable<WebinarVideoShareDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarVideoShareDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarVideoShareDTO[]>(null as any);
    }

    /**
     * @param webinarShipmentId (optional)
     * @param body (optional)
     * @return OK
     */
    createUSPSLabel(webinarShipmentId: number | undefined, body: USPSLabelRequest | undefined): Observable<USPSLabelResponse> {
        let url_ = this.baseUrl + "/CreateUSPSLabel?";
        if (webinarShipmentId === null)
            throw new Error("The parameter 'webinarShipmentId' cannot be null.");
        else if (webinarShipmentId !== undefined)
            url_ += "webinarShipmentId=" + encodeURIComponent("" + webinarShipmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUSPSLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUSPSLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<USPSLabelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<USPSLabelResponse>;
        }));
    }

    /**
     * @param webinarShipmentId (optional) 
     * @param body (optional) 
     * @return OK
     */
    getUSPSPrice(webinarShipmentId: number | undefined, body: USPSLabelRequest | undefined): Observable<USPSPriceResponse> {
        let url_ = this.baseUrl + "/GetUSPSPrice?";
        if (webinarShipmentId === null)
            throw new Error("The parameter 'webinarShipmentId' cannot be null.");
        else if (webinarShipmentId !== undefined)
            url_ += "webinarShipmentId=" + encodeURIComponent("" + webinarShipmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUSPSPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUSPSPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<USPSPriceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<USPSPriceResponse>;
        }));
    }

    protected processGetUSPSPrice(response: HttpResponseBase): Observable<USPSPriceResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = USPSPriceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<USPSPriceResponse>(null as any);
    }

    getSavedFromAddress(webinarRoomId: number | undefined): Observable<WebinarRoomOwnerFromAddress> {
        let url_ = this.baseUrl + "/GetSavedFromAddress?";
        if (webinarRoomId === null)
            throw new Error("The parameter 'webinarRoomId' cannot be null.");
        else if (webinarRoomId !== undefined)
            url_ += "webinarRoomId=" + encodeURIComponent("" + webinarRoomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSavedFromAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSavedFromAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarRoomOwnerFromAddress>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarRoomOwnerFromAddress>;
        }));
    }

    protected processGetSavedFromAddress(response: HttpResponseBase): Observable<WebinarRoomOwnerFromAddress> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? WebinarRoomOwnerFromAddress.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarRoomOwnerFromAddress>(null as any);
    }

    protected processCreateUSPSLabel(response: HttpResponseBase): Observable<USPSLabelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? USPSLabelResponse.fromJS(resultData200) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<USPSLabelResponse>(null as any);
    }
}

export interface IInterestedHostClient {
    /**
     * @return OK
     */
    getCurrentOnlineSellers(): Observable<CurrentOnlineSeller[]>;
    /**
     * @return OK
     */
    getYearsIntoBusiness(): Observable<YearsIntoBusiness[]>;
    /**
     * @return OK
     */
    getOnlineRatingCompany(): Observable<OnlineRatingCompany[]>;
    /**
     * @return OK
     */
    getSubscriberRange(): Observable<SubscriberRange[]>;
    /**
     * @return OK
     */
    getItemsToSell(): Observable<ItemsToSell[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createInterestedHost(body: InterestedHost | undefined): Observable<InterestedHost>;
    /**
     * @param fileUpload (optional) 
     * @return OK
     */
    uploadBusinessImage(id: number, fileUpload: FileParameter | undefined): Observable<boolean>;
    /**
     * @param fileUpload (optional) 
     * @return OK
     */
    uploadFFLImage(id: number, fileUpload: FileParameter | undefined): Observable<boolean>;
    /**
     * @return OK
     */
    getRequests(): Observable<InterestedHost[]>;
    /**
     * @return OK
     */
    approveRequest(requestId: number, sisterwebsiteId: number): Observable<ResponseDTO>;
    /**
     * @return OK
     */
    rejectRequest(requestId: number): Observable<ResponseDTO>;
    /**
     * @return OK
     */
    getFFLImages(roomId: number): Observable<WebinarRoomFFLImage[]>;
    /**
     * @return OK
     */
    getSisterWebsites(): Observable<SisterWebsite[]>;
    /**
     * @param fileUpload (optional) 
     * @param description (optional) 
     * @return OK
     */
    updateBusinessImageForRoom(roomId: number, fileUpload: FileParameter | undefined, description: string | undefined): Observable<boolean>;
}

@Injectable()
export class InterestedHostClient implements IInterestedHostClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentOnlineSellers(): Observable<CurrentOnlineSeller[]> {
        let url_ = this.baseUrl + "/GetCurrentOnlineSellers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentOnlineSellers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentOnlineSellers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentOnlineSeller[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentOnlineSeller[]>;
        }));
    }

    protected processGetCurrentOnlineSellers(response: HttpResponseBase): Observable<CurrentOnlineSeller[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurrentOnlineSeller.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentOnlineSeller[]>(null as any);
    }

    /**
     * @return OK
     */
    getYearsIntoBusiness(): Observable<YearsIntoBusiness[]> {
        let url_ = this.baseUrl + "/GetYearsIntoBusiness";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearsIntoBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearsIntoBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YearsIntoBusiness[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YearsIntoBusiness[]>;
        }));
    }

    protected processGetYearsIntoBusiness(response: HttpResponseBase): Observable<YearsIntoBusiness[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(YearsIntoBusiness.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<YearsIntoBusiness[]>(null as any);
    }

    /**
     * @return OK
     */
    getOnlineRatingCompany(): Observable<OnlineRatingCompany[]> {
        let url_ = this.baseUrl + "/GetOnlineRatingCompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineRatingCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineRatingCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnlineRatingCompany[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnlineRatingCompany[]>;
        }));
    }

    protected processGetOnlineRatingCompany(response: HttpResponseBase): Observable<OnlineRatingCompany[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnlineRatingCompany.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnlineRatingCompany[]>(null as any);
    }

    /**
     * @return OK
     */
    getSubscriberRange(): Observable<SubscriberRange[]> {
        let url_ = this.baseUrl + "/GetSubscriberRange";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriberRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriberRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriberRange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriberRange[]>;
        }));
    }

    protected processGetSubscriberRange(response: HttpResponseBase): Observable<SubscriberRange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberRange.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriberRange[]>(null as any);
    }

    /**
     * @return OK
     */
    getItemsToSell(): Observable<ItemsToSell[]> {
        let url_ = this.baseUrl + "/GetItemsToSell";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemsToSell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemsToSell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemsToSell[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemsToSell[]>;
        }));
    }

    protected processGetItemsToSell(response: HttpResponseBase): Observable<ItemsToSell[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemsToSell.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemsToSell[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInterestedHost(body: InterestedHost | undefined): Observable<InterestedHost> {
        let url_ = this.baseUrl + "/CreateInterestedHost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInterestedHost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInterestedHost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterestedHost>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterestedHost>;
        }));
    }

    protected processCreateInterestedHost(response: HttpResponseBase): Observable<InterestedHost> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterestedHost.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InterestedHost>(null as any);
    }

    /**
     * @param fileUpload (optional) 
     * @return OK
     */
    uploadBusinessImage(id: number, fileUpload: FileParameter | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/InterestedHost/UploadBusinessImage/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUpload === null || fileUpload === undefined)
            throw new Error("The parameter 'fileUpload' cannot be null.");
        else
            content_.append("fileUpload", fileUpload.data, fileUpload.fileName ? fileUpload.fileName : "fileUpload");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBusinessImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBusinessImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadBusinessImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param fileUpload (optional) 
     * @return OK
     */
    uploadFFLImage(id: number, fileUpload: FileParameter | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/InterestedHost/UploadFFLImage/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUpload === null || fileUpload === undefined)
            throw new Error("The parameter 'fileUpload' cannot be null.");
        else
            content_.append("fileUpload", fileUpload.data, fileUpload.fileName ? fileUpload.fileName : "fileUpload");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFFLImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFFLImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadFFLImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getRequests(): Observable<InterestedHost[]> {
        let url_ = this.baseUrl + "/api/InterestedHost/GetRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterestedHost[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterestedHost[]>;
        }));
    }

    protected processGetRequests(response: HttpResponseBase): Observable<InterestedHost[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterestedHost.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InterestedHost[]>(null as any);
    }

    /**
     * @return OK
     */
    approveRequest(requestId: number, sisterwebsiteId: number): Observable<ResponseDTO> {
        let url_ = this.baseUrl + "/api/InterestedHost/ApproveRequest/{requestId}/{sisterwebsiteId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        if (sisterwebsiteId === undefined || sisterwebsiteId === null)
            throw new Error("The parameter 'sisterwebsiteId' must be defined.");
        url_ = url_.replace("{sisterwebsiteId}", encodeURIComponent("" + sisterwebsiteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseDTO>;
        }));
    }

    protected processApproveRequest(response: HttpResponseBase): Observable<ResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    rejectRequest(requestId: number): Observable<ResponseDTO> {
        let url_ = this.baseUrl + "/api/InterestedHost/RejectRequest/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseDTO>;
        }));
    }

    protected processRejectRequest(response: HttpResponseBase): Observable<ResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    getFFLImages(roomId: number): Observable<WebinarRoomFFLImage[]> {
        let url_ = this.baseUrl + "/api/InterestedHost/GetFFLImages/{roomId}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFFLImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFFLImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarRoomFFLImage[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarRoomFFLImage[]>;
        }));
    }

    protected processGetFFLImages(response: HttpResponseBase): Observable<WebinarRoomFFLImage[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarRoomFFLImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarRoomFFLImage[]>(null as any);
    }

    /**
     * @return OK
     */
    getSisterWebsites(): Observable<SisterWebsite[]> {
        let url_ = this.baseUrl + "/api/InterestedHost/GetSisterWebsites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSisterWebsites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSisterWebsites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SisterWebsite[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SisterWebsite[]>;
        }));
    }

    protected processGetSisterWebsites(response: HttpResponseBase): Observable<SisterWebsite[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SisterWebsite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SisterWebsite[]>(null as any);
    }

    /**
     * @param fileUpload (optional) 
     * @param description (optional) 
     * @return OK
     */
    updateBusinessImageForRoom(roomId: number, fileUpload: FileParameter | undefined, description: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/InterestedHost/UpdateBusinessImageForRoom/{roomId}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUpload === null || fileUpload === undefined)
            throw new Error("The parameter 'fileUpload' cannot be null.");
        else
            content_.append("fileUpload", fileUpload.data, fileUpload.fileName ? fileUpload.fileName : "fileUpload");
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusinessImageForRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusinessImageForRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateBusinessImageForRoom(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IMyAccountClient {
    /**
     * @return OK
     */
    getStateList(): Observable<StateList[]>;
    /**
     * @return OK
     */
    getPurchaseHistory(userId: number): Observable<PurchaseHistoryDTO[]>;
    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getPurchaseHistoryPaged(userId: number, pageNumber: number | undefined, pageSize: number | undefined): Observable<PurchaseHistoryDTOPagedResult>;
    /**
     * @return OK
     */
    getWebinarFreeWinings(userId: number): Observable<WebinarFreeWinningDTO[]>;
    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getWebinarFreeWiningsPaged(userId: number, pageNumber: number | undefined, pageSize: number | undefined): Observable<WebinarFreeWinningDTOPagedResult>;
    /**
     * @return OK
     */
    getCommunicationMethod(userId: number): Observable<CommunicationsMethod>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveCommunicationMethod(body: CommunicationsMethod | undefined): Observable<CommunicationsMethod>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateCommnunicationMethod(body: CommunicationsMethod | undefined): Observable<boolean>;
    /**
     * @return OK
     */
    getInquiryType(userId: string): Observable<InquiryType[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveInquiry(body: Inquiry | undefined): Observable<Inquiry>;
    /**
     * @return OK
     */
    getBillingAddress(userId: number): Observable<BillingAddress>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveBillingAddress(body: BillingAddress | undefined): Observable<BillingAddress>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateBillingAddress(userId: number, body: BillingAddress | undefined): Observable<BillingAddress>;
    /**
     * @return OK
     */
    getShippingAddress(userId: number): Observable<ShippingAddress>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveShippingAddress(body: ShippingAddress | undefined): Observable<ShippingAddress>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateShippingAddress(userId: number, body: ShippingAddress | undefined): Observable<ShippingAddress>;
    /**
     * @return OK
     */
    generateEmailOtp(emailId: string, reason: string): Observable<number>;
    /**
     * @return OK
     */
    verifyOtp(requestId: number, otp: string, emailId: string): Observable<boolean>;
    /**
     * @return OK
     */
    sendMobileOtp(emailId: string, reason: string): Observable<number>;
    /**
     * @return OK
     */
    getUserComForForgotPassword(emailId: string): Observable<UserComDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    validateAddress(body: USPSAddressValidationRequest | undefined): Observable<USPSAddressValidationResponse>;
}

@Injectable()
export class MyAccountClient implements IMyAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getStateList(): Observable<StateList[]> {
        let url_ = this.baseUrl + "/GetStateList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateList[]>;
        }));
    }

    protected processGetStateList(response: HttpResponseBase): Observable<StateList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StateList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StateList[]>(null as any);
    }

    /**
     * @return OK
     */
    getPurchaseHistory(userId: number): Observable<PurchaseHistoryDTO[]> {
        let url_ = this.baseUrl + "/GetPurchaseHistory/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseHistoryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseHistoryDTO[]>;
        }));
    }

    protected processGetPurchaseHistory(response: HttpResponseBase): Observable<PurchaseHistoryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurchaseHistoryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseHistoryDTO[]>(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getPurchaseHistoryPaged(userId: number, pageNumber: number | undefined, pageSize: number | undefined): Observable<PurchaseHistoryDTOPagedResult> {
        let url_ = this.baseUrl + "/GetPurchaseHistoryPaged/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseHistoryPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseHistoryPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseHistoryDTOPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseHistoryDTOPagedResult>;
        }));
    }

    protected processGetPurchaseHistoryPaged(response: HttpResponseBase): Observable<PurchaseHistoryDTOPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseHistoryDTOPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseHistoryDTOPagedResult>(null as any);
    }

    /**
     * @return OK
     */
    getWebinarFreeWinings(userId: number): Observable<WebinarFreeWinningDTO[]> {
        let url_ = this.baseUrl + "/GetWebinarFreeWinings/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebinarFreeWinings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebinarFreeWinings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarFreeWinningDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarFreeWinningDTO[]>;
        }));
    }

    protected processGetWebinarFreeWinings(response: HttpResponseBase): Observable<WebinarFreeWinningDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarFreeWinningDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarFreeWinningDTO[]>(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getWebinarFreeWiningsPaged(userId: number, pageNumber: number | undefined, pageSize: number | undefined): Observable<WebinarFreeWinningDTOPagedResult> {
        let url_ = this.baseUrl + "/GetWebinarFreeWiningsPaged/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebinarFreeWiningsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebinarFreeWiningsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarFreeWinningDTOPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarFreeWinningDTOPagedResult>;
        }));
    }

    protected processGetWebinarFreeWiningsPaged(response: HttpResponseBase): Observable<WebinarFreeWinningDTOPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebinarFreeWinningDTOPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarFreeWinningDTOPagedResult>(null as any);
    }

    /**
     * @return OK
     */
    getCommunicationMethod(userId: number): Observable<CommunicationsMethod> {
        let url_ = this.baseUrl + "/getCommunicationMethod/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationMethod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationsMethod>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationsMethod>;
        }));
    }

    protected processGetCommunicationMethod(response: HttpResponseBase): Observable<CommunicationsMethod> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationsMethod.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsMethod>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCommunicationMethod(body: CommunicationsMethod | undefined): Observable<CommunicationsMethod> {
        let url_ = this.baseUrl + "/saveCommunicationMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCommunicationMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCommunicationMethod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationsMethod>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationsMethod>;
        }));
    }

    protected processSaveCommunicationMethod(response: HttpResponseBase): Observable<CommunicationsMethod> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationsMethod.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsMethod>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCommnunicationMethod(body: CommunicationsMethod | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/UpdateCommnunicationMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommnunicationMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommnunicationMethod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateCommnunicationMethod(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getInquiryType(userId: string): Observable<InquiryType[]> {
        let url_ = this.baseUrl + "/getInquiryType/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInquiryType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInquiryType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InquiryType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InquiryType[]>;
        }));
    }

    protected processGetInquiryType(response: HttpResponseBase): Observable<InquiryType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InquiryType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InquiryType[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveInquiry(body: Inquiry | undefined): Observable<Inquiry> {
        let url_ = this.baseUrl + "/saveInquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Inquiry>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Inquiry>;
        }));
    }

    protected processSaveInquiry(response: HttpResponseBase): Observable<Inquiry> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Inquiry.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Inquiry>(null as any);
    }

    /**
     * @return OK
     */
    getBillingAddress(userId: number): Observable<BillingAddress> {
        let url_ = this.baseUrl + "/getBillingAddress/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingAddress>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingAddress>;
        }));
    }

    protected processGetBillingAddress(response: HttpResponseBase): Observable<BillingAddress> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingAddress.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillingAddress>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveBillingAddress(body: BillingAddress | undefined): Observable<BillingAddress> {
        let url_ = this.baseUrl + "/saveBillingAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBillingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBillingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingAddress>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingAddress>;
        }));
    }

    protected processSaveBillingAddress(response: HttpResponseBase): Observable<BillingAddress> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingAddress.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillingAddress>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBillingAddress(userId: number, body: BillingAddress | undefined): Observable<BillingAddress> {
        let url_ = this.baseUrl + "/updateBillingAddress/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBillingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingAddress>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingAddress>;
        }));
    }

    protected processUpdateBillingAddress(response: HttpResponseBase): Observable<BillingAddress> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingAddress.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillingAddress>(null as any);
    }

    /**
     * @return OK
     */
    getShippingAddress(userId: number): Observable<ShippingAddress> {
        let url_ = this.baseUrl + "/getShippingAddress/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingAddress>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingAddress>;
        }));
    }

    protected processGetShippingAddress(response: HttpResponseBase): Observable<ShippingAddress> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingAddress.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingAddress>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveShippingAddress(body: ShippingAddress | undefined): Observable<ShippingAddress> {
        let url_ = this.baseUrl + "/saveShippingAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingAddress>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingAddress>;
        }));
    }

    protected processSaveShippingAddress(response: HttpResponseBase): Observable<ShippingAddress> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingAddress.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingAddress>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateShippingAddress(userId: number, body: ShippingAddress | undefined): Observable<ShippingAddress> {
        let url_ = this.baseUrl + "/updateShippingAddress/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingAddress>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingAddress>;
        }));
    }

    protected processUpdateShippingAddress(response: HttpResponseBase): Observable<ShippingAddress> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingAddress.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingAddress>(null as any);
    }

    /**
     * @return OK
     */
    generateEmailOtp(emailId: string, reason: string): Observable<number> {
        let url_ = this.baseUrl + "/GenerateEmailOtp/{emailId}/{reason}";
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        if (reason === undefined || reason === null)
            throw new Error("The parameter 'reason' must be defined.");
        url_ = url_.replace("{reason}", encodeURIComponent("" + reason));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmailOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmailOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGenerateEmailOtp(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    verifyOtp(requestId: number, otp: string, emailId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/VerifyOtp/{requestId}/{otp}/{emailId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        if (otp === undefined || otp === null)
            throw new Error("The parameter 'otp' must be defined.");
        url_ = url_.replace("{otp}", encodeURIComponent("" + otp));
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyOtp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendMobileOtp(emailId: string, reason: string): Observable<number> {
        let url_ = this.baseUrl + "/SendMobileOtp/{emailId}/{reason}";
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        if (reason === undefined || reason === null)
            throw new Error("The parameter 'reason' must be defined.");
        url_ = url_.replace("{reason}", encodeURIComponent("" + reason));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMobileOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMobileOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendMobileOtp(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getUserComForForgotPassword(emailId: string): Observable<UserComDTO> {
        let url_ = this.baseUrl + "/GetUserComForForgotPassword/{emailId}";
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserComForForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserComForForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserComDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserComDTO>;
        }));
    }

    protected processGetUserComForForgotPassword(response: HttpResponseBase): Observable<UserComDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserComDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserComDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateAddress(body: USPSAddressValidationRequest | undefined): Observable<USPSAddressValidationResponse> {
        let url_ = this.baseUrl + "/ValidateAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<USPSAddressValidationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<USPSAddressValidationResponse>;
        }));
    }

    protected processValidateAddress(response: HttpResponseBase): Observable<USPSAddressValidationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = USPSAddressValidationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<USPSAddressValidationResponse>(null as any);
    }
}

export interface IPaymentClient {
    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    savePayment(userId: number | undefined, body: PaymentDTO | undefined): Observable<PaymentInfo>;
    /**
     * @return OK
     */
    getUserSavedCardDetails(userId: number): Observable<CardDetail[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveCardDetails(body: CardDetail | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateCardDetails(cardId: number, body: CardDetail | undefined): Observable<boolean>;
    /**
     * @return OK
     */
    deleteUserCardDetail(cardId: number): Observable<boolean>;
    /**
     * @return OK
     */
    getTransactionDetailsFromNmiGateway(transactionId: string): Observable<UsaePayQueryResponse>;
    /**
     * @return OK
     */
    getRefundPaymentInfoForHostPortal(roomId: number): Observable<RefundPaymentInfo[]>;
}

@Injectable()
export class PaymentClient implements IPaymentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    savePayment(userId: number | undefined, body: PaymentDTO | undefined): Observable<PaymentInfo> {
        let url_ = this.baseUrl + "/api/Payment/SavePayment?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentInfo>;
        }));
    }

    protected processSavePayment(response: HttpResponseBase): Observable<PaymentInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentInfo>(null as any);
    }

    /**
     * @return OK
     */
    getUserSavedCardDetails(userId: number): Observable<CardDetail[]> {
        let url_ = this.baseUrl + "/api/Payment/GetUserSavedCardDetails/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSavedCardDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSavedCardDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDetail[]>;
        }));
    }

    protected processGetUserSavedCardDetails(response: HttpResponseBase): Observable<CardDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardDetail[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCardDetails(body: CardDetail | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Payment/SaveCardDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCardDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCardDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveCardDetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCardDetails(cardId: number, body: CardDetail | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Payment/UpdateCardDetails/{cardId}";
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCardDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCardDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateCardDetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteUserCardDetail(cardId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Payment/DeleteUserCardDetail/{cardId}";
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserCardDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserCardDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteUserCardDetail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getTransactionDetailsFromNmiGateway(transactionId: string): Observable<UsaePayQueryResponse> {
        let url_ = this.baseUrl + "/api/Payment/GetTransactionDetailsFromNmiGateway/{transactionId}";
        if (transactionId === undefined || transactionId === null)
            throw new Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionDetailsFromNmiGateway(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionDetailsFromNmiGateway(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsaePayQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsaePayQueryResponse>;
        }));
    }

    protected processGetTransactionDetailsFromNmiGateway(response: HttpResponseBase): Observable<UsaePayQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsaePayQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UsaePayQueryResponse>(null as any);
    }

    /**
     * @return OK
     */
    getRefundPaymentInfoForHostPortal(roomId: number): Observable<RefundPaymentInfo[]> {
        let url_ = this.baseUrl + "/api/Payment/GetRefundPaymentInfoForHostPortal/{roomId}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRefundPaymentInfoForHostPortal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRefundPaymentInfoForHostPortal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefundPaymentInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefundPaymentInfo[]>;
        }));
    }

    protected processGetRefundPaymentInfoForHostPortal(response: HttpResponseBase): Observable<RefundPaymentInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefundPaymentInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefundPaymentInfo[]>(null as any);
    }
}

export interface IPlatformChargesClient {
    /**
     * @return OK
     */
    getAll(): Observable<PlatformChargesGetDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addPlatformCharge(userId: number, body: RoomOwnerPlatformCharge | undefined): Observable<RoomOwnerPlatformCharge>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updatePlatformCharge(userId: number, body: RoomOwnerPlatformCharge | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addRoomOwnerAccountDetail(userId: number, body: RoomOwnerAccountDetail | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateRoomOwnerAccountDetail(userId: number, body: RoomOwnerAccountDetail | undefined): Observable<boolean>;
    /**
     * @return OK
     */
    deleteAccountDetail(accoutDetailId: number): Observable<boolean>;
    /**
     * @return OK
     */
    markRoomOwnerAccountDetailActive(accountDetailId: number, userId: number): Observable<boolean>;
    /**
     * @return OK
     */
    getAllAccountDetails(userId: number): Observable<RoomOwnerAccountDetail[]>;
    /**
     * @param fileUpload (optional) 
     * @return OK
     */
    uploadSettlementFile(settlementIds: string, fileUpload: FileParameter | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addWebinarSettlement(userId: number, body: WebinarSettlementDetail[] | undefined): Observable<number[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateWebinarSettlement(userId: number, body: WebinarSettlementDetail | undefined): Observable<boolean>;
    /**
     * @return OK
     */
    getRoomOwnerActiveAccount(roomOwnerId: number): Observable<RoomOwnerAccountDetail>;
    /**
     * @return OK
     */
    getRoomOwnerPlatformCharge(roomOwnerId: number): Observable<RoomOwnerPlatformCharge>;
    /**
     * @return OK
     */
    getAllWebinarAccountSettled(roomId: number): Observable<WebinarSettlementDetail[]>;
    /**
     * @return OK
     */
    getAllWebinarAccountSettledForAdmin(): Observable<WebinarSettlementDetail[]>;
    /**
     * @return OK
     */
    getRoomWiseSettlementBetweenDates(roomId: number, fromDate: Date, toDate: Date): Observable<WebinarSettlementDetail[]>;
}

@Injectable()
export class PlatformChargesClient implements IPlatformChargesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAll(): Observable<PlatformChargesGetDTO[]> {
        let url_ = this.baseUrl + "/api/PlatformCharges/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlatformChargesGetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlatformChargesGetDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PlatformChargesGetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlatformChargesGetDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlatformChargesGetDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addPlatformCharge(userId: number, body: RoomOwnerPlatformCharge | undefined): Observable<RoomOwnerPlatformCharge> {
        let url_ = this.baseUrl + "/api/PlatformCharges/AddPlatformCharge/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPlatformCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPlatformCharge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomOwnerPlatformCharge>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomOwnerPlatformCharge>;
        }));
    }

    protected processAddPlatformCharge(response: HttpResponseBase): Observable<RoomOwnerPlatformCharge> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomOwnerPlatformCharge.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoomOwnerPlatformCharge>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePlatformCharge(userId: number, body: RoomOwnerPlatformCharge | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PlatformCharges/UpdatePlatformCharge/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePlatformCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePlatformCharge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePlatformCharge(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addRoomOwnerAccountDetail(userId: number, body: RoomOwnerAccountDetail | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PlatformCharges/AddRoomOwnerAccountDetail/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRoomOwnerAccountDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRoomOwnerAccountDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddRoomOwnerAccountDetail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateRoomOwnerAccountDetail(userId: number, body: RoomOwnerAccountDetail | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PlatformCharges/UpdateRoomOwnerAccountDetail/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoomOwnerAccountDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoomOwnerAccountDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateRoomOwnerAccountDetail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteAccountDetail(accoutDetailId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PlatformCharges/DeleteAccountDetail/{accoutDetailId}";
        if (accoutDetailId === undefined || accoutDetailId === null)
            throw new Error("The parameter 'accoutDetailId' must be defined.");
        url_ = url_.replace("{accoutDetailId}", encodeURIComponent("" + accoutDetailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccountDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccountDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAccountDetail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markRoomOwnerAccountDetailActive(accountDetailId: number, userId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PlatformCharges/MarkRoomOwnerAccountDetailActive/{accountDetailId}/{userId}";
        if (accountDetailId === undefined || accountDetailId === null)
            throw new Error("The parameter 'accountDetailId' must be defined.");
        url_ = url_.replace("{accountDetailId}", encodeURIComponent("" + accountDetailId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkRoomOwnerAccountDetailActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkRoomOwnerAccountDetailActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkRoomOwnerAccountDetailActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAllAccountDetails(userId: number): Observable<RoomOwnerAccountDetail[]> {
        let url_ = this.baseUrl + "/api/PlatformCharges/GetAllAccountDetails/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAccountDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAccountDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomOwnerAccountDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomOwnerAccountDetail[]>;
        }));
    }

    protected processGetAllAccountDetails(response: HttpResponseBase): Observable<RoomOwnerAccountDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomOwnerAccountDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoomOwnerAccountDetail[]>(null as any);
    }

    /**
     * @param fileUpload (optional) 
     * @return OK
     */
    uploadSettlementFile(settlementIds: string, fileUpload: FileParameter | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PlatformCharges/UploadSettlementFile/{settlementIds}";
        if (settlementIds === undefined || settlementIds === null)
            throw new Error("The parameter 'settlementIds' must be defined.");
        url_ = url_.replace("{settlementIds}", encodeURIComponent("" + settlementIds));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUpload === null || fileUpload === undefined)
            throw new Error("The parameter 'fileUpload' cannot be null.");
        else
            content_.append("fileUpload", fileUpload.data, fileUpload.fileName ? fileUpload.fileName : "fileUpload");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSettlementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSettlementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadSettlementFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addWebinarSettlement(userId: number, body: WebinarSettlementDetail[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/PlatformCharges/AddWebinarSettlement/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWebinarSettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWebinarSettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddWebinarSettlement(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateWebinarSettlement(userId: number, body: WebinarSettlementDetail | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PlatformCharges/UpdateWebinarSettlement/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWebinarSettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWebinarSettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWebinarSettlement(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getRoomOwnerActiveAccount(roomOwnerId: number): Observable<RoomOwnerAccountDetail> {
        let url_ = this.baseUrl + "/api/PlatformCharges/GetRoomOwnerActiveAccount/{roomOwnerId}";
        if (roomOwnerId === undefined || roomOwnerId === null)
            throw new Error("The parameter 'roomOwnerId' must be defined.");
        url_ = url_.replace("{roomOwnerId}", encodeURIComponent("" + roomOwnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomOwnerActiveAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomOwnerActiveAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomOwnerAccountDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomOwnerAccountDetail>;
        }));
    }

    protected processGetRoomOwnerActiveAccount(response: HttpResponseBase): Observable<RoomOwnerAccountDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomOwnerAccountDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoomOwnerAccountDetail>(null as any);
    }

    /**
     * @return OK
     */
    getRoomOwnerPlatformCharge(roomOwnerId: number): Observable<RoomOwnerPlatformCharge> {
        let url_ = this.baseUrl + "/api/PlatformCharges/GetRoomOwnerPlatformCharge/{roomOwnerId}";
        if (roomOwnerId === undefined || roomOwnerId === null)
            throw new Error("The parameter 'roomOwnerId' must be defined.");
        url_ = url_.replace("{roomOwnerId}", encodeURIComponent("" + roomOwnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomOwnerPlatformCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomOwnerPlatformCharge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomOwnerPlatformCharge>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomOwnerPlatformCharge>;
        }));
    }

    protected processGetRoomOwnerPlatformCharge(response: HttpResponseBase): Observable<RoomOwnerPlatformCharge> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomOwnerPlatformCharge.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoomOwnerPlatformCharge>(null as any);
    }

    /**
     * @return OK
     */
    getAllWebinarAccountSettled(roomId: number): Observable<WebinarSettlementDetail[]> {
        let url_ = this.baseUrl + "/api/PlatformCharges/GetAllWebinarAccountSettled/{roomId}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWebinarAccountSettled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWebinarAccountSettled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarSettlementDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarSettlementDetail[]>;
        }));
    }

    protected processGetAllWebinarAccountSettled(response: HttpResponseBase): Observable<WebinarSettlementDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarSettlementDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarSettlementDetail[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllWebinarAccountSettledForAdmin(): Observable<WebinarSettlementDetail[]> {
        let url_ = this.baseUrl + "/api/PlatformCharges/GetAllWebinarAccountSettledForAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWebinarAccountSettledForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWebinarAccountSettledForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarSettlementDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarSettlementDetail[]>;
        }));
    }

    protected processGetAllWebinarAccountSettledForAdmin(response: HttpResponseBase): Observable<WebinarSettlementDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarSettlementDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarSettlementDetail[]>(null as any);
    }

    /**
     * @return OK
     */
    getRoomWiseSettlementBetweenDates(roomId: number, fromDate: Date, toDate: Date): Observable<WebinarSettlementDetail[]> {
        let url_ = this.baseUrl + "/api/PlatformCharges/GetRoomWiseSettlementBetweenDates/{roomId}/{fromDate}/{toDate}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomWiseSettlementBetweenDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomWiseSettlementBetweenDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarSettlementDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarSettlementDetail[]>;
        }));
    }

    protected processGetRoomWiseSettlementBetweenDates(response: HttpResponseBase): Observable<WebinarSettlementDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarSettlementDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarSettlementDetail[]>(null as any);
    }
}

export interface IProductClient {
    /**
     * @return OK
     */
    getProducts(): Observable<Product[]>;
    /**
     * @return OK
     */
    getProduct(productId: number): Observable<Product>;
    /**
     * @param body (optional) 
     * @return OK
     */
    product(body: Product | undefined): Observable<Product>;
}

@Injectable()
export class ProductClient implements IProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getProducts(): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/Product/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product[]>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product[]>(null as any);
    }

    /**
     * @return OK
     */
    getProduct(productId: number): Observable<Product> {
        let url_ = this.baseUrl + "/api/Product/GetProduct/{ProductId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{ProductId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    product(body: Product | undefined): Observable<Product> {
        let url_ = this.baseUrl + "/api/Product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product>;
        }));
    }

    protected processProduct(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product>(null as any);
    }
}

export interface IUserClient {
    /**
     * @return OK
     */
    getUsers(): Observable<User[]>;
    /**
     * @param emailId (optional) 
     * @param password (optional) 
     * @return OK
     */
    validateUser(emailId: string | undefined, password: string | undefined): Observable<User>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createUser(body: AddUser | undefined): Observable<User>;
    /**
     * @return OK
     */
    generateEmailVerificationLink(emailId: string): Observable<boolean>;
    /**
     * @return OK
     */
    verifyEmail(value1: string, value2: string): Observable<string>;
    /**
     * @return OK
     */
    passowrdReset(emailId: string, password: string, requestId: number): Observable<boolean>;
}

@Injectable()
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getUsers(): Observable<User[]> {
        let url_ = this.baseUrl + "/api/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User[]>(null as any);
    }

    /**
     * @param emailId (optional) 
     * @param password (optional) 
     * @return OK
     */
    validateUser(emailId: string | undefined, password: string | undefined): Observable<User> {
        let url_ = this.baseUrl + "/api/User/ValidateUser?";
        if (emailId === null)
            throw new Error("The parameter 'emailId' cannot be null.");
        else if (emailId !== undefined)
            url_ += "emailId=" + encodeURIComponent("" + emailId) + "&";
        if (password === null)
            throw new Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processValidateUser(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createUser(body: AddUser | undefined): Observable<User> {
        let url_ = this.baseUrl + "/api/User/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(null as any);
    }

    /**
     * @return OK
     */
    generateEmailVerificationLink(emailId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/GenerateEmailVerificationLink/{emailId}";
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmailVerificationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmailVerificationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGenerateEmailVerificationLink(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    verifyEmail(value1: string, value2: string): Observable<string> {
        let url_ = this.baseUrl + "/VerifyEmail/{value1}/{value2}";
        if (value1 === undefined || value1 === null)
            throw new Error("The parameter 'value1' must be defined.");
        url_ = url_.replace("{value1}", encodeURIComponent("" + value1));
        if (value2 === undefined || value2 === null)
            throw new Error("The parameter 'value2' must be defined.");
        url_ = url_.replace("{value2}", encodeURIComponent("" + value2));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processVerifyEmail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    passowrdReset(emailId: string, password: string, requestId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/PassowrdReset/{emailId}/{password}/{requestId}";
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined.");
        url_ = url_.replace("{password}", encodeURIComponent("" + password));
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPassowrdReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPassowrdReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPassowrdReset(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IWalletClient {
    /**
     * @return OK
     */
    getBalance(userId: number): Observable<WalletBalanceDTO>;
    /**
     * @return OK
     */
    getAvailableBalance(userId: number): Observable<number>;
    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getTransactions(userId: number, pageNumber: number | undefined, pageSize: number | undefined): Observable<WalletTransaction[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addCredit(body: AddWalletCreditDTO | undefined): Observable<Wallet>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addCreditToAllUsers(body: AddWalletCreditDTO | undefined): Observable<number>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addCreditToUsersList(body: AddWalletCreditDTO | undefined): Observable<number>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deductPayment(body: WalletPaymentDTO | undefined): Observable<boolean>;
}

@Injectable()
export class WalletClient implements IWalletClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getBalance(userId: number): Observable<WalletBalanceDTO> {
        let url_ = this.baseUrl + "/api/Wallet/GetBalance/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletBalanceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletBalanceDTO>;
        }));
    }

    protected processGetBalance(response: HttpResponseBase): Observable<WalletBalanceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletBalanceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WalletBalanceDTO>(null as any);
    }

    /**
     * @return OK
     */
    getAvailableBalance(userId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Wallet/GetAvailableBalance/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAvailableBalance(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getTransactions(userId: number, pageNumber: number | undefined, pageSize: number | undefined): Observable<WalletTransaction[]> {
        let url_ = this.baseUrl + "/api/Wallet/GetTransactions/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletTransaction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletTransaction[]>;
        }));
    }

    protected processGetTransactions(response: HttpResponseBase): Observable<WalletTransaction[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletTransaction.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WalletTransaction[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addCredit(body: AddWalletCreditDTO | undefined): Observable<Wallet> {
        let url_ = this.baseUrl + "/api/Wallet/AddCredit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCredit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCredit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Wallet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Wallet>;
        }));
    }

    protected processAddCredit(response: HttpResponseBase): Observable<Wallet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Wallet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Wallet>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addCreditToAllUsers(body: AddWalletCreditDTO | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Wallet/AddCreditToAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCreditToAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCreditToAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddCreditToAllUsers(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addCreditToUsersList(body: AddWalletCreditDTO | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Wallet/AddCreditToUsersList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCreditToUsersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCreditToUsersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddCreditToUsersList(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deductPayment(body: WalletPaymentDTO | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Wallet/DeductPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeductPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeductPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeductPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IWeatherForecastClient {
    /**
     * @return OK
     */
    weatherForecast(): Observable<WeatherForecast[]>;
}

@Injectable()
export class WeatherForecastClient implements IWeatherForecastClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    weatherForecast(): Observable<WeatherForecast[]> {
        let url_ = this.baseUrl + "/WeatherForecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWeatherForecast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWeatherForecast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeatherForecast[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeatherForecast[]>;
        }));
    }

    protected processWeatherForecast(response: HttpResponseBase): Observable<WeatherForecast[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WeatherForecast[]>(null as any);
    }
}

export interface IWebinarClient {
    /**
     * @return OK
     */
    getWebinars(roomId: number): Observable<Webinar[]>;
    /**
     * @return OK
     */
    getTopWebinars(): Observable<Webinar[]>;
    /**
     * @return OK
     */
    getRecentWebinarCovers(): Observable<Webinar[]>;
    /**
     * @return OK
     */
    getRecentWinners(): Observable<RecentWinnerDTO[]>;
    /**
     * @return OK
     */
    getWebinarRooms(getImages: boolean): Observable<WebinarRoom[]>;
    /**
     * @return OK
     */
    getWebinarRoomsByUser(userId: number): Observable<WebinarRoomOwnerDTO[]>;
    /**
     * @return OK
     */
    getWebinar(webinarId: number): Observable<Webinar>;
    /**
     * Rewatch link target: only resolves when the caller purchased a seat or hosts the room, else the server returns 403.
     * @return OK
     */
    getRewatchVideo(webinarId: number): Observable<RewatchVideoDTO>;
    /**
     * @return OK
     */
    current(): Observable<Date>;
    /**
     * @param fileUploadImage (optional) 
     * @param fileUploadVideo (optional) 
     * @return OK
     */
    uploadImageBlob(webinarId: number, fileUploadImage: FileParameter[] | undefined, fileUploadVideo: FileParameter[] | undefined): Observable<boolean>;
    /**
     * @param fileUploadImage (optional) 
     * @param fileUploadVideo (optional) 
     * @return OK
     */
    updateWebinarUploadedBlobs(webinarId: number, fileUploadImage: FileParameter[] | undefined, fileUploadVideo: FileParameter[] | undefined): Observable<boolean>;
    /**
     * @param fileUploadImage (optional) 
     * @param fileUploadVideo (optional) 
     * @return OK
     */
    uploadImageBlobIphone(webinarId: number, fileUploadImage: FileParameter[] | undefined, fileUploadVideo: FileParameter[] | undefined): Observable<boolean>;
    /**
     * @param fileUploadImage (optional) 
     * @param fileUploadVideo (optional) 
     * @return OK
     */
    updateWebinarUploadedBlobsIphone(webinarId: number, fileUploadImage: FileParameter[] | undefined, fileUploadVideo: FileParameter[] | undefined): Observable<boolean>;
    /**
     * @return OK
     */
    getBlobImage(webinarId: number): Observable<string[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    webinar(body: Webinar | undefined): Observable<Webinar>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateWebinar(body: Webinar | undefined): Observable<boolean>;
    /**
     * @return OK
     */
    getSeats(webinarId: number): Observable<Webinar>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createWebinarReview(body: WebinarReview | undefined): Observable<WebinarReview>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createReviewHelpScore(body: WebinarReviewHelpScore | undefined): Observable<WebinarReviewHelpScore>;
    /**
     * @return OK
     */
    deleteReviewHelpScore(reviewScoreId: number): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateWebinarReview(body: WebinarReview | undefined): Observable<boolean>;
    /**
     * @return OK
     */
    deleteWebinarReview(reviewId: number): Observable<boolean>;
    /**
     * @return OK
     */
    getAllMAppedRoomsList(): Observable<WebinarRoomDTO[]>;
    /**
     * @return OK
     */
    getRoomWiseRevenue(roomId: number, fromDate: Date, toDate: Date): Observable<RoomWiseRevenueDTO>;
    /**
     * @return OK
     */
    getRoomWiseAccountSettlementDetails(roomId: number): Observable<WebinarSettlementDetailsGetDTO[]>;
    /**
     * @return OK
     */
    getRoomWiseAccountSettlementDetailsForAllRooms(includeUnsoldSeats?: boolean, includePendingShipping?: boolean): Observable<WebinarSettlementDetailsForAllDto[]>;
    /**
     * @return OK
     */
    checkWebinarNameIsAvailable(webinarName: string, roomId: number): Observable<boolean>;
    /**
     * @return OK
     */
    deleteUnsusedWebinar(webinarId: number): Observable<boolean>;
    /**
     * @return OK
     */
    checkSeatsInWebinarForUser(webinarId: number): Observable<number>;
}

@Injectable()
export class WebinarClient implements IWebinarClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getWebinars(roomId: number): Observable<Webinar[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetWebinars/{RoomId}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{RoomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebinars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebinars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Webinar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Webinar[]>;
        }));
    }

    protected processGetWebinars(response: HttpResponseBase): Observable<Webinar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Webinar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Webinar[]>(null as any);
    }

    /**
     * Rewatch link target: only resolves when the caller purchased a seat or hosts the room, else the server returns 403.
     * @return OK
     */
    getRewatchVideo(webinarId: number): Observable<RewatchVideoDTO> {
        let url_ = this.baseUrl + "/api/Webinar/GetRewatchVideo/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRewatchVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRewatchVideo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RewatchVideoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RewatchVideoDTO>;
        }));
    }

    protected processGetRewatchVideo(response: HttpResponseBase): Observable<RewatchVideoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RewatchVideoDTO.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewatchVideoDTO>(null as any);
    }

    /**
     * @return OK
     */
    getTopWebinars(): Observable<Webinar[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetTopWebinars";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopWebinars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopWebinars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Webinar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Webinar[]>;
        }));
    }

    protected processGetTopWebinars(response: HttpResponseBase): Observable<Webinar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Webinar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Webinar[]>(null as any);
    }

    /**
     * @return OK
     */
    getRecentWebinarCovers(): Observable<Webinar[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetRecentWebinarCovers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopWebinars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopWebinars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Webinar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Webinar[]>;
        }));
    }

    /**
     * @return OK
     */
    getRecentWinners(): Observable<RecentWinnerDTO[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetRecentWinners";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentWinners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentWinners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentWinnerDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentWinnerDTO[]>;
        }));
    }

    protected processGetRecentWinners(response: HttpResponseBase): Observable<RecentWinnerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecentWinnerDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentWinnerDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getWebinarRooms(getImages: boolean): Observable<WebinarRoom[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetWebinarRooms/{getImages}";
        if (getImages === undefined || getImages === null)
            throw new Error("The parameter 'getImages' must be defined.");
        url_ = url_.replace("{getImages}", encodeURIComponent("" + getImages));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebinarRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebinarRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarRoom[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarRoom[]>;
        }));
    }

    protected processGetWebinarRooms(response: HttpResponseBase): Observable<WebinarRoom[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarRoom.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarRoom[]>(null as any);
    }

    /**
     * @return OK
     */
    getWebinarRoomsByUser(userId: number): Observable<WebinarRoomOwnerDTO[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetWebinarRoomsByUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebinarRoomsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebinarRoomsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarRoomOwnerDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarRoomOwnerDTO[]>;
        }));
    }

    protected processGetWebinarRoomsByUser(response: HttpResponseBase): Observable<WebinarRoomOwnerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarRoomOwnerDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarRoomOwnerDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getWebinar(webinarId: number): Observable<Webinar> {
        let url_ = this.baseUrl + "/api/Webinar/GetWebinar/{WebinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{WebinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebinar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebinar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Webinar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Webinar>;
        }));
    }

    protected processGetWebinar(response: HttpResponseBase): Observable<Webinar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Webinar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Webinar>(null as any);
    }

    /**
     * @return OK
     */
    current(): Observable<Date> {
        let url_ = this.baseUrl + "/api/Webinar/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processCurrent(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Date>(null as any);
    }

    /**
     * @param fileUploadImage (optional) 
     * @param fileUploadVideo (optional) 
     * @return OK
     */
    uploadImageBlob(webinarId: number, fileUploadImage: FileParameter[] | undefined, fileUploadVideo: FileParameter[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/UploadImageBlob/{WebinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{WebinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUploadImage === null || fileUploadImage === undefined)
            throw new Error("The parameter 'fileUploadImage' cannot be null.");
        else
            fileUploadImage.forEach(item_ => content_.append("fileUploadImage", item_.data, item_.fileName ? item_.fileName : "fileUploadImage") );
        if (fileUploadVideo === null || fileUploadVideo === undefined)
            throw new Error("The parameter 'fileUploadVideo' cannot be null.");
        else
            fileUploadVideo.forEach(item_ => content_.append("fileUploadVideo", item_.data, item_.fileName ? item_.fileName : "fileUploadVideo") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadImageBlob(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param fileUploadImage (optional) 
     * @param fileUploadVideo (optional) 
     * @return OK
     */
    updateWebinarUploadedBlobs(webinarId: number, fileUploadImage: FileParameter[] | undefined, fileUploadVideo: FileParameter[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/UpdateWebinarUploadedBlobs/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUploadImage === null || fileUploadImage === undefined)
            throw new Error("The parameter 'fileUploadImage' cannot be null.");
        else
            fileUploadImage.forEach(item_ => content_.append("fileUploadImage", item_.data, item_.fileName ? item_.fileName : "fileUploadImage") );
        if (fileUploadVideo === null || fileUploadVideo === undefined)
            throw new Error("The parameter 'fileUploadVideo' cannot be null.");
        else
            fileUploadVideo.forEach(item_ => content_.append("fileUploadVideo", item_.data, item_.fileName ? item_.fileName : "fileUploadVideo") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWebinarUploadedBlobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWebinarUploadedBlobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWebinarUploadedBlobs(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param fileUploadImage (optional) 
     * @param fileUploadVideo (optional) 
     * @return OK
     */
    uploadImageBlobIphone(webinarId: number, fileUploadImage: FileParameter[] | undefined, fileUploadVideo: FileParameter[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/UploadImageBlobIphone/{WebinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{WebinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUploadImage === null || fileUploadImage === undefined)
            throw new Error("The parameter 'fileUploadImage' cannot be null.");
        else
            fileUploadImage.forEach(item_ => content_.append("fileUploadImage", item_.data, item_.fileName ? item_.fileName : "fileUploadImage") );
        if (fileUploadVideo === null || fileUploadVideo === undefined)
            throw new Error("The parameter 'fileUploadVideo' cannot be null.");
        else
            fileUploadVideo.forEach(item_ => content_.append("fileUploadVideo", item_.data, item_.fileName ? item_.fileName : "fileUploadVideo") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageBlobIphone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageBlobIphone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadImageBlobIphone(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param fileUploadImage (optional) 
     * @param fileUploadVideo (optional) 
     * @return OK
     */
    updateWebinarUploadedBlobsIphone(webinarId: number, fileUploadImage: FileParameter[] | undefined, fileUploadVideo: FileParameter[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/UpdateWebinarUploadedBlobsIphone/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileUploadImage === null || fileUploadImage === undefined)
            throw new Error("The parameter 'fileUploadImage' cannot be null.");
        else
            fileUploadImage.forEach(item_ => content_.append("fileUploadImage", item_.data, item_.fileName ? item_.fileName : "fileUploadImage") );
        if (fileUploadVideo === null || fileUploadVideo === undefined)
            throw new Error("The parameter 'fileUploadVideo' cannot be null.");
        else
            fileUploadVideo.forEach(item_ => content_.append("fileUploadVideo", item_.data, item_.fileName ? item_.fileName : "fileUploadVideo") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWebinarUploadedBlobsIphone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWebinarUploadedBlobsIphone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWebinarUploadedBlobsIphone(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getBlobImage(webinarId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetBlobImage/{WebinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{WebinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlobImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlobImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetBlobImage(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    webinar(body: Webinar | undefined): Observable<Webinar> {
        let url_ = this.baseUrl + "/api/Webinar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebinar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebinar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Webinar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Webinar>;
        }));
    }

    protected processWebinar(response: HttpResponseBase): Observable<Webinar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Webinar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Webinar>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateWebinar(body: Webinar | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/UpdateWebinar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWebinar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWebinar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWebinar(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getSeats(webinarId: number): Observable<Webinar> {
        let url_ = this.baseUrl + "/api/Webinar/GetSeats/{WebinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{WebinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Webinar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Webinar>;
        }));
    }

    protected processGetSeats(response: HttpResponseBase): Observable<Webinar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Webinar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Webinar>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createWebinarReview(body: WebinarReview | undefined): Observable<WebinarReview> {
        let url_ = this.baseUrl + "/api/Webinar/CreateWebinarReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWebinarReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWebinarReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarReview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarReview>;
        }));
    }

    protected processCreateWebinarReview(response: HttpResponseBase): Observable<WebinarReview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebinarReview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarReview>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createReviewHelpScore(body: WebinarReviewHelpScore | undefined): Observable<WebinarReviewHelpScore> {
        let url_ = this.baseUrl + "/api/Webinar/CreateReviewHelpScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReviewHelpScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReviewHelpScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarReviewHelpScore>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarReviewHelpScore>;
        }));
    }

    protected processCreateReviewHelpScore(response: HttpResponseBase): Observable<WebinarReviewHelpScore> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebinarReviewHelpScore.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarReviewHelpScore>(null as any);
    }

    /**
     * @return OK
     */
    deleteReviewHelpScore(reviewScoreId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/DeleteReviewHelpScore/{reviewScoreId}";
        if (reviewScoreId === undefined || reviewScoreId === null)
            throw new Error("The parameter 'reviewScoreId' must be defined.");
        url_ = url_.replace("{reviewScoreId}", encodeURIComponent("" + reviewScoreId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReviewHelpScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReviewHelpScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteReviewHelpScore(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateWebinarReview(body: WebinarReview | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/UpdateWebinarReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWebinarReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWebinarReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWebinarReview(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteWebinarReview(reviewId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/DeleteWebinarReview/{reviewId}";
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWebinarReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWebinarReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteWebinarReview(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAllMAppedRoomsList(): Observable<WebinarRoomDTO[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetAllMAppedRoomsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMAppedRoomsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMAppedRoomsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarRoomDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarRoomDTO[]>;
        }));
    }

    protected processGetAllMAppedRoomsList(response: HttpResponseBase): Observable<WebinarRoomDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarRoomDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarRoomDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getRoomWiseRevenue(roomId: number, fromDate: Date, toDate: Date): Observable<RoomWiseRevenueDTO> {
        let url_ = this.baseUrl + "/api/Webinar/GetRoomWiseRevenue/{roomId}/{fromDate}/{toDate}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomWiseRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomWiseRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomWiseRevenueDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomWiseRevenueDTO>;
        }));
    }

    protected processGetRoomWiseRevenue(response: HttpResponseBase): Observable<RoomWiseRevenueDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomWiseRevenueDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoomWiseRevenueDTO>(null as any);
    }

    /**
     * @return OK
     */
    getRoomWiseAccountSettlementDetails(roomId: number): Observable<WebinarSettlementDetailsGetDTO[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetRoomWiseAccountSettlementDetails/{roomId}";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomWiseAccountSettlementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomWiseAccountSettlementDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarSettlementDetailsGetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarSettlementDetailsGetDTO[]>;
        }));
    }

    protected processGetRoomWiseAccountSettlementDetails(response: HttpResponseBase): Observable<WebinarSettlementDetailsGetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarSettlementDetailsGetDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarSettlementDetailsGetDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getRoomWiseAccountSettlementDetailsForAllRooms(includeUnsoldSeats?: boolean, includePendingShipping?: boolean): Observable<WebinarSettlementDetailsForAllDto[]> {
        let url_ = this.baseUrl + "/api/Webinar/GetRoomWiseAccountSettlementDetailsForAllRooms";
        const queryParams: string[] = [];
        if (includeUnsoldSeats !== undefined && includeUnsoldSeats !== null)
            queryParams.push("includeUnsoldSeats=" + encodeURIComponent("" + includeUnsoldSeats));
        if (includePendingShipping !== undefined && includePendingShipping !== null)
            queryParams.push("includePendingShipping=" + encodeURIComponent("" + includePendingShipping));
        if (queryParams.length > 0)
            url_ += "?" + queryParams.join("&");
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomWiseAccountSettlementDetailsForAllRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomWiseAccountSettlementDetailsForAllRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarSettlementDetailsForAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarSettlementDetailsForAllDto[]>;
        }));
    }

    protected processGetRoomWiseAccountSettlementDetailsForAllRooms(response: HttpResponseBase): Observable<WebinarSettlementDetailsForAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebinarSettlementDetailsForAllDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarSettlementDetailsForAllDto[]>(null as any);
    }

    /**
     * @return OK
     */
    checkWebinarNameIsAvailable(webinarName: string, roomId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/CheckWebinarNameIsAvailable/{WebinarName}/{RoomId}";
        if (webinarName === undefined || webinarName === null)
            throw new Error("The parameter 'webinarName' must be defined.");
        url_ = url_.replace("{WebinarName}", encodeURIComponent("" + webinarName));
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{RoomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckWebinarNameIsAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWebinarNameIsAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckWebinarNameIsAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteUnsusedWebinar(webinarId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Webinar/DeleteUnsusedWebinar/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUnsusedWebinar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUnsusedWebinar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteUnsusedWebinar(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    checkSeatsInWebinarForUser(webinarId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Webinar/CheckSeatsInWebinarForUser/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSeatsInWebinarForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSeatsInWebinarForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckSeatsInWebinarForUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

export interface IWebinarRunClient {
    /**
     * @param webinarGuid (optional) 
     * @return OK
     */
    getWebinarRun(webinarGuid: string | undefined): Observable<WebinarRunDTO>;
    /**
     * @param webinarGuid (optional) 
     * @return OK
     */
    update(webinarGuid: string | undefined): Observable<void>;
}

@Injectable()
export class WebinarRunClient implements IWebinarRunClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param webinarGuid (optional) 
     * @return OK
     */
    getWebinarRun(webinarGuid: string | undefined): Observable<WebinarRunDTO> {
        let url_ = this.baseUrl + "/GetWebinarRun?";
        if (webinarGuid === null)
            throw new Error("The parameter 'webinarGuid' cannot be null.");
        else if (webinarGuid !== undefined)
            url_ += "webinarGuid=" + encodeURIComponent("" + webinarGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebinarRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebinarRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebinarRunDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebinarRunDTO>;
        }));
    }

    protected processGetWebinarRun(response: HttpResponseBase): Observable<WebinarRunDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebinarRunDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebinarRunDTO>(null as any);
    }

    /**
     * @param webinarGuid (optional) 
     * @return OK
     */
    update(webinarGuid: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Update?";
        if (webinarGuid === null)
            throw new Error("The parameter 'webinarGuid' cannot be null.");
        else if (webinarGuid !== undefined)
            url_ += "webinarGuid=" + encodeURIComponent("" + webinarGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AddUser {
    firstName!: string | undefined;
    lastName!: string | undefined;
    roleId!: number;
    password!: string | undefined;
    active!: boolean;
    emailId!: string | undefined;
    isNotificationEnabled!: boolean;
    isHost!: boolean;
    isOwner!: boolean;
    token!: string | undefined;
    isEmailVerified!: boolean;
    role!: Role;
    userContactInfos!: UserContactInfo[] | undefined;
    userNotifications!: UserNotification[] | undefined;
    shipingStreetAddress!: string | undefined;
    shipingCity!: string | undefined;
    shipingState!: string | undefined;
    shipingZipCode!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.roleId = _data["roleId"];
            this.password = _data["password"];
            this.active = _data["active"];
            this.emailId = _data["emailId"];
            this.isNotificationEnabled = _data["isNotificationEnabled"];
            this.isHost = _data["isHost"];
            this.isOwner = _data["isOwner"];
            this.token = _data["token"];
            this.isEmailVerified = _data["isEmailVerified"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["userContactInfos"])) {
                this.userContactInfos = [] as any;
                for (let item of _data["userContactInfos"])
                    this.userContactInfos!.push(UserContactInfo.fromJS(item));
            }
            if (Array.isArray(_data["userNotifications"])) {
                this.userNotifications = [] as any;
                for (let item of _data["userNotifications"])
                    this.userNotifications!.push(UserNotification.fromJS(item));
            }
            this.shipingStreetAddress = _data["shipingStreetAddress"];
            this.shipingCity = _data["shipingCity"];
            this.shipingState = _data["shipingState"];
            this.shipingZipCode = _data["shipingZipCode"];
        }
    }

    static fromJS(data: any): AddUser {
        data = typeof data === 'object' ? data : {};
        let result = new AddUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["roleId"] = this.roleId;
        data["password"] = this.password;
        data["active"] = this.active;
        data["emailId"] = this.emailId;
        data["isNotificationEnabled"] = this.isNotificationEnabled;
        data["isHost"] = this.isHost;
        data["isOwner"] = this.isOwner;
        data["token"] = this.token;
        data["isEmailVerified"] = this.isEmailVerified;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.userContactInfos)) {
            data["userContactInfos"] = [];
            for (let item of this.userContactInfos)
                data["userContactInfos"].push(item.toJSON());
        }
        if (Array.isArray(this.userNotifications)) {
            data["userNotifications"] = [];
            for (let item of this.userNotifications)
                data["userNotifications"].push(item.toJSON());
        }
        data["shipingStreetAddress"] = this.shipingStreetAddress;
        data["shipingCity"] = this.shipingCity;
        data["shipingState"] = this.shipingState;
        data["shipingZipCode"] = this.shipingZipCode;
        return data;
    }
}

export class AddWalletCreditDTO {
    userId!: number | undefined;
    userIdList!: number[] | undefined;
    amount!: number;
    description!: string | undefined;
    alsoAddToNewUsers!: boolean;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["userIdList"])) {
                this.userIdList = [] as any;
                for (let item of _data["userIdList"])
                    this.userIdList!.push(item);
            }
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.alsoAddToNewUsers = _data["alsoAddToNewUsers"];
        }
    }

    static fromJS(data: any): AddWalletCreditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddWalletCreditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.userIdList)) {
            data["userIdList"] = [];
            for (let item of this.userIdList)
                data["userIdList"].push(item);
        }
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["alsoAddToNewUsers"] = this.alsoAddToNewUsers;
        return data;
    }
}

export class AmountDetailQuery {
    tax!: string | undefined;
    subtotal!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.tax = _data["tax"];
            this.subtotal = _data["subtotal"];
        }
    }

    static fromJS(data: any): AmountDetailQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AmountDetailQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tax"] = this.tax;
        data["subtotal"] = this.subtotal;
        return data;
    }
}

export class BatchQuery {
    type!: string | undefined;
    key!: string | undefined;
    batchrefnum!: string | undefined;
    sequence!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.key = _data["key"];
            this.batchrefnum = _data["batchrefnum"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): BatchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BatchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["key"] = this.key;
        data["batchrefnum"] = this.batchrefnum;
        data["sequence"] = this.sequence;
        return data;
    }
}

export class BillingAddress {
    id!: number;
    name!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    stateId!: number;
    zipCode!: number;
    userId!: number;
    isActive!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zipCode = _data["zipCode"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BillingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new BillingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zipCode"] = this.zipCode;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export class CardDetail {
    id!: number;
    cardNumber!: string;
    cardExpiryMonth!: string;
    cardExpiryYear!: string;
    cardCvv!: string | undefined;
    cardHolderName!: string;
    isActive!: boolean;
    userId!: number;
    user!: User;
    detailsAddedOn!: Date;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardNumber = _data["cardNumber"];
            this.cardExpiryMonth = _data["cardExpiryMonth"];
            this.cardExpiryYear = _data["cardExpiryYear"];
            this.cardCvv = _data["cardCvv"];
            this.cardHolderName = _data["cardHolderName"];
            this.isActive = _data["isActive"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.detailsAddedOn = _data["detailsAddedOn"] ? new Date(_data["detailsAddedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CardDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CardDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardNumber"] = this.cardNumber;
        data["cardExpiryMonth"] = this.cardExpiryMonth;
        data["cardExpiryYear"] = this.cardExpiryYear;
        data["cardCvv"] = this.cardCvv;
        data["cardHolderName"] = this.cardHolderName;
        data["isActive"] = this.isActive;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["detailsAddedOn"] = this.detailsAddedOn ? this.detailsAddedOn.toISOString() : <any>undefined;
        return data;
    }
}

export class Cart {
    cartId!: number;
    cartName!: string | undefined;
    userId!: number;
    user!: User;
    cartDetails!: CartDetail[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.cartName = _data["cartName"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["cartDetails"])) {
                this.cartDetails = [] as any;
                for (let item of _data["cartDetails"])
                    this.cartDetails!.push(CartDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Cart {
        data = typeof data === 'object' ? data : {};
        let result = new Cart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["cartName"] = this.cartName;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.cartDetails)) {
            data["cartDetails"] = [];
            for (let item of this.cartDetails)
                data["cartDetails"].push(item.toJSON());
        }
        return data;
    }
}

export class CartCheckoutResponseDTO {
    isOrderItemsSaved!: boolean;
    isOrderPlaced!: boolean;
    orderId!: string | undefined;
    message!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.isOrderItemsSaved = _data["isOrderItemsSaved"];
            this.isOrderPlaced = _data["isOrderPlaced"];
            this.orderId = _data["orderId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CartCheckoutResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CartCheckoutResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOrderItemsSaved"] = this.isOrderItemsSaved;
        data["isOrderPlaced"] = this.isOrderPlaced;
        data["orderId"] = this.orderId;
        data["message"] = this.message;
        return data;
    }
}

export class CartDetail {
    cartItemId!: number;
    cartId!: number;
    webinarId!: number;
    seatId!: number;
    seatNumber!: string | undefined;
    createdDate!: Date;
    webinar!: Webinar;
    active!: boolean;

    init(_data?: any) {
        if (_data) {
            this.cartItemId = _data["cartItemId"];
            this.cartId = _data["cartId"];
            this.webinarId = _data["webinarId"];
            this.seatId = _data["seatId"];
            this.seatNumber = _data["seatNumber"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.webinar = _data["webinar"] ? Webinar.fromJS(_data["webinar"]) : <any>undefined;
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CartDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CartDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartItemId"] = this.cartItemId;
        data["cartId"] = this.cartId;
        data["webinarId"] = this.webinarId;
        data["seatId"] = this.seatId;
        data["seatNumber"] = this.seatNumber;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["webinar"] = this.webinar ? this.webinar.toJSON() : <any>undefined;
        data["active"] = this.active;
        return data;
    }
}

export class CommunicationsMethod {
    id!: number;
    userId!: number;
    phone!: number;
    email!: string | undefined;
    textConcent!: boolean | undefined;
    phoneNumberConcent!: boolean | undefined;
    isActive!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.textConcent = _data["textConcent"];
            this.phoneNumberConcent = _data["phoneNumberConcent"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CommunicationsMethod {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationsMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["textConcent"] = this.textConcent;
        data["phoneNumberConcent"] = this.phoneNumberConcent;
        data["isActive"] = this.isActive;
        return data;
    }
}

export class CreditcardQuery {
    cardholder!: string | undefined;
    number!: string | undefined;
    category_code!: string | undefined;
    type!: string | undefined;
    entry_mode!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.cardholder = _data["cardholder"];
            this.number = _data["number"];
            this.category_code = _data["category_code"];
            this.type = _data["type"];
            this.entry_mode = _data["entry_mode"];
        }
    }

    static fromJS(data: any): CreditcardQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CreditcardQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardholder"] = this.cardholder;
        data["number"] = this.number;
        data["category_code"] = this.category_code;
        data["type"] = this.type;
        data["entry_mode"] = this.entry_mode;
        return data;
    }
}

export class CurrentOnlineSeller {
    id!: number;
    name!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CurrentOnlineSeller {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentOnlineSeller();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export class Faq {
    id!: number;
    question!: string | undefined;
    answer!: string | undefined;
    active!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Faq {
        data = typeof data === 'object' ? data : {};
        let result = new Faq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["active"] = this.active;
        return data;
    }
}

export class HistoricalSalesDTO {
    webinarId!: number;
    webinarName!: string | undefined;
    status!: string | undefined;
    selectedSeatId!: number | undefined;
    cost!: number | undefined;
    startDate!: Date;
    closeDateTime!: Date | undefined;
    webinarSeats!: SeatPurchaseInfo[] | undefined;
    videoRecordingPath!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.webinarId = _data["webinarId"];
            this.webinarName = _data["webinarName"];
            this.status = _data["status"];
            this.selectedSeatId = _data["selectedSeatId"];
            this.cost = _data["cost"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.closeDateTime = _data["closeDateTime"] ? new Date(_data["closeDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["webinarSeats"])) {
                this.webinarSeats = [] as any;
                for (let item of _data["webinarSeats"])
                    this.webinarSeats!.push(SeatPurchaseInfo.fromJS(item));
            }
            this.videoRecordingPath = _data["videoRecordingPath"];
        }
    }

    static fromJS(data: any): HistoricalSalesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalSalesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webinarId"] = this.webinarId;
        data["webinarName"] = this.webinarName;
        data["status"] = this.status;
        data["selectedSeatId"] = this.selectedSeatId;
        data["cost"] = this.cost;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["closeDateTime"] = this.closeDateTime ? this.closeDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.webinarSeats)) {
            data["webinarSeats"] = [];
            for (let item of this.webinarSeats)
                data["webinarSeats"].push(item.toJSON());
        }
        data["videoRecordingPath"] = this.videoRecordingPath;
        return data;
    }
}

export class HistoricalSalesInputDTO {
    webinarRoomId!: number;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    statusId!: number[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.webinarRoomId = _data["webinarRoomId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["statusId"])) {
                this.statusId = [] as any;
                for (let item of _data["statusId"])
                    this.statusId!.push(item);
            }
        }
    }

    static fromJS(data: any): HistoricalSalesInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalSalesInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webinarRoomId"] = this.webinarRoomId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.statusId)) {
            data["statusId"] = [];
            for (let item of this.statusId)
                data["statusId"].push(item);
        }
        return data;
    }
}

export class ShareWebinarRecordingRequest {
    webinarId!: number;
    recipientUserIds!: number[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.webinarId = _data["webinarId"];
            if (Array.isArray(_data["recipientUserIds"])) {
                this.recipientUserIds = [] as any;
                for (let item of _data["recipientUserIds"])
                    this.recipientUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ShareWebinarRecordingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShareWebinarRecordingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webinarId"] = this.webinarId;
        if (Array.isArray(this.recipientUserIds)) {
            data["recipientUserIds"] = [];
            for (let item of this.recipientUserIds)
                data["recipientUserIds"].push(item);
        }
        return data;
    }
}

export class WebinarVideoShareDTO {
    id!: number;
    webinarId!: number;
    sharedToUserId!: number;
    sharedToName!: string | undefined;
    sharedToEmail!: string | undefined;
    sharedDate!: Date;
    emailSent!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webinarId = _data["webinarId"];
            this.sharedToUserId = _data["sharedToUserId"];
            this.sharedToName = _data["sharedToName"];
            this.sharedToEmail = _data["sharedToEmail"];
            this.sharedDate = _data["sharedDate"] ? new Date(_data["sharedDate"].toString()) : <any>undefined;
            this.emailSent = _data["emailSent"];
        }
    }

    static fromJS(data: any): WebinarVideoShareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarVideoShareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webinarId"] = this.webinarId;
        data["sharedToUserId"] = this.sharedToUserId;
        data["sharedToName"] = this.sharedToName;
        data["sharedToEmail"] = this.sharedToEmail;
        data["sharedDate"] = this.sharedDate ? this.sharedDate.toISOString() : <any>undefined;
        data["emailSent"] = this.emailSent;
        return data;
    }
}

export class RewatchVideoDTO {
    webinarId!: number;
    webinarName!: string | undefined;
    videoPath!: string | undefined;
    posterImageUrl!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.webinarId = _data["webinarId"];
            this.webinarName = _data["webinarName"];
            this.videoPath = _data["videoPath"];
            this.posterImageUrl = _data["posterImageUrl"];
        }
    }

    static fromJS(data: any): RewatchVideoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RewatchVideoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webinarId"] = this.webinarId;
        data["webinarName"] = this.webinarName;
        data["videoPath"] = this.videoPath;
        data["posterImageUrl"] = this.posterImageUrl;
        return data;
    }
}

export class Inquiry {
    id!: number;
    inquiryTypeId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    openText!: string | undefined;
    webinarRoomId!: number | undefined;
    isEmailSent!: boolean | undefined;
    isActive!: boolean;
    createdBy!: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inquiryTypeId = _data["inquiryTypeId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.openText = _data["openText"];
            this.webinarRoomId = _data["webinarRoomId"];
            this.isEmailSent = _data["isEmailSent"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): Inquiry {
        data = typeof data === 'object' ? data : {};
        let result = new Inquiry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inquiryTypeId"] = this.inquiryTypeId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["openText"] = this.openText;
        data["webinarRoomId"] = this.webinarRoomId;
        data["isEmailSent"] = this.isEmailSent;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export class InquiryType {
    id!: number;
    name!: string | undefined;
    isActive!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): InquiryType {
        data = typeof data === 'object' ? data : {};
        let result = new InquiryType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export class InterestedHost {
    id!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    isCurrentOnlineSeller!: boolean | undefined;
    consent!: boolean;
    whyStrongSeller!: string | undefined;
    submittedBy!: number | undefined;
    submittedDate!: Date;
    requestId!: string | undefined;
    submittedByNavigation!: User;
    interestedHostDetails!: InterestedHostDetail[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.isCurrentOnlineSeller = _data["isCurrentOnlineSeller"];
            this.consent = _data["consent"];
            this.whyStrongSeller = _data["whyStrongSeller"];
            this.submittedBy = _data["submittedBy"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.requestId = _data["requestId"];
            this.submittedByNavigation = _data["submittedByNavigation"] ? User.fromJS(_data["submittedByNavigation"]) : <any>undefined;
            if (Array.isArray(_data["interestedHostDetails"])) {
                this.interestedHostDetails = [] as any;
                for (let item of _data["interestedHostDetails"])
                    this.interestedHostDetails!.push(InterestedHostDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InterestedHost {
        data = typeof data === 'object' ? data : {};
        let result = new InterestedHost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["isCurrentOnlineSeller"] = this.isCurrentOnlineSeller;
        data["consent"] = this.consent;
        data["whyStrongSeller"] = this.whyStrongSeller;
        data["submittedBy"] = this.submittedBy;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["requestId"] = this.requestId;
        data["submittedByNavigation"] = this.submittedByNavigation ? this.submittedByNavigation.toJSON() : <any>undefined;
        if (Array.isArray(this.interestedHostDetails)) {
            data["interestedHostDetails"] = [];
            for (let item of this.interestedHostDetails)
                data["interestedHostDetails"].push(item.toJSON());
        }
        return data;
    }
}

export class InterestedHostCurrentSeller {
    id!: number;
    interestedHostDetailsId!: number;
    currentOnlineSellerId!: number;
    pageLink!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestedHostDetailsId = _data["interestedHostDetailsId"];
            this.currentOnlineSellerId = _data["currentOnlineSellerId"];
            this.pageLink = _data["pageLink"];
        }
    }

    static fromJS(data: any): InterestedHostCurrentSeller {
        data = typeof data === 'object' ? data : {};
        let result = new InterestedHostCurrentSeller();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestedHostDetailsId"] = this.interestedHostDetailsId;
        data["currentOnlineSellerId"] = this.currentOnlineSellerId;
        data["pageLink"] = this.pageLink;
        return data;
    }
}

export class InterestedHostDetail {
    id!: number;
    interestedHostId!: number;
    businessName!: string | undefined;
    businessDba!: string | undefined;
    businessAddress!: string | undefined;
    businessPhoneNumber!: string | undefined;
    yearsInBusinessId!: number | undefined;
    onlineRatingCompanyId!: number | undefined;
    onlineRatingScore!: number | undefined;
    primaryItemsId!: number | undefined;
    secondayItemId!: number | undefined;
    howManySubscribersId!: number | undefined;
    taxId!: string | undefined;
    ssn!: string | undefined;
    termAndCondition!: boolean;
    paymentPolicy!: boolean;
    resolutionAndDisputePolicy!: boolean;
    shippingPolicy!: boolean;
    privacyPolicy!: boolean;
    createdDate!: Date;
    signature!: string | undefined;
    companyName!: string | undefined;
    prefferedRoomName!: string | undefined;
    howManySubscribers!: SubscriberRange;
    interestedHost!: InterestedHost;
    onlineRatingCompany!: OnlineRatingCompany;
    primaryItems!: ItemsToSell;
    secondayItem!: ItemsToSell;
    yearsInBusiness!: YearsIntoBusiness;
    interestedHostCurrentSellers!: InterestedHostCurrentSeller[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestedHostId = _data["interestedHostId"];
            this.businessName = _data["businessName"];
            this.businessDba = _data["businessDba"];
            this.businessAddress = _data["businessAddress"];
            this.businessPhoneNumber = _data["businessPhoneNumber"];
            this.yearsInBusinessId = _data["yearsInBusinessId"];
            this.onlineRatingCompanyId = _data["onlineRatingCompanyId"];
            this.onlineRatingScore = _data["onlineRatingScore"];
            this.primaryItemsId = _data["primaryItemsId"];
            this.secondayItemId = _data["secondayItemId"];
            this.howManySubscribersId = _data["howManySubscribersId"];
            this.taxId = _data["taxId"];
            this.ssn = _data["ssn"];
            this.termAndCondition = _data["termAndCondition"];
            this.paymentPolicy = _data["paymentPolicy"];
            this.resolutionAndDisputePolicy = _data["resolutionAndDisputePolicy"];
            this.shippingPolicy = _data["shippingPolicy"];
            this.privacyPolicy = _data["privacyPolicy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.signature = _data["signature"];
            this.companyName = _data["companyName"];
            this.prefferedRoomName = _data["prefferedRoomName"];
            this.howManySubscribers = _data["howManySubscribers"] ? SubscriberRange.fromJS(_data["howManySubscribers"]) : <any>undefined;
            this.interestedHost = _data["interestedHost"] ? InterestedHost.fromJS(_data["interestedHost"]) : <any>undefined;
            this.onlineRatingCompany = _data["onlineRatingCompany"] ? OnlineRatingCompany.fromJS(_data["onlineRatingCompany"]) : <any>undefined;
            this.primaryItems = _data["primaryItems"] ? ItemsToSell.fromJS(_data["primaryItems"]) : <any>undefined;
            this.secondayItem = _data["secondayItem"] ? ItemsToSell.fromJS(_data["secondayItem"]) : <any>undefined;
            this.yearsInBusiness = _data["yearsInBusiness"] ? YearsIntoBusiness.fromJS(_data["yearsInBusiness"]) : <any>undefined;
            if (Array.isArray(_data["interestedHostCurrentSellers"])) {
                this.interestedHostCurrentSellers = [] as any;
                for (let item of _data["interestedHostCurrentSellers"])
                    this.interestedHostCurrentSellers!.push(InterestedHostCurrentSeller.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InterestedHostDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InterestedHostDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestedHostId"] = this.interestedHostId;
        data["businessName"] = this.businessName;
        data["businessDba"] = this.businessDba;
        data["businessAddress"] = this.businessAddress;
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["yearsInBusinessId"] = this.yearsInBusinessId;
        data["onlineRatingCompanyId"] = this.onlineRatingCompanyId;
        data["onlineRatingScore"] = this.onlineRatingScore;
        data["primaryItemsId"] = this.primaryItemsId;
        data["secondayItemId"] = this.secondayItemId;
        data["howManySubscribersId"] = this.howManySubscribersId;
        data["taxId"] = this.taxId;
        data["ssn"] = this.ssn;
        data["termAndCondition"] = this.termAndCondition;
        data["paymentPolicy"] = this.paymentPolicy;
        data["resolutionAndDisputePolicy"] = this.resolutionAndDisputePolicy;
        data["shippingPolicy"] = this.shippingPolicy;
        data["privacyPolicy"] = this.privacyPolicy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["signature"] = this.signature;
        data["companyName"] = this.companyName;
        data["prefferedRoomName"] = this.prefferedRoomName;
        data["howManySubscribers"] = this.howManySubscribers ? this.howManySubscribers.toJSON() : <any>undefined;
        data["interestedHost"] = this.interestedHost ? this.interestedHost.toJSON() : <any>undefined;
        data["onlineRatingCompany"] = this.onlineRatingCompany ? this.onlineRatingCompany.toJSON() : <any>undefined;
        data["primaryItems"] = this.primaryItems ? this.primaryItems.toJSON() : <any>undefined;
        data["secondayItem"] = this.secondayItem ? this.secondayItem.toJSON() : <any>undefined;
        data["yearsInBusiness"] = this.yearsInBusiness ? this.yearsInBusiness.toJSON() : <any>undefined;
        if (Array.isArray(this.interestedHostCurrentSellers)) {
            data["interestedHostCurrentSellers"] = [];
            for (let item of this.interestedHostCurrentSellers)
                data["interestedHostCurrentSellers"].push(item.toJSON());
        }
        return data;
    }
}

export class ItemsToSell {
    id!: number;
    name!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ItemsToSell {
        data = typeof data === 'object' ? data : {};
        let result = new ItemsToSell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export class MyShipmentsDTO {
    nonShippedWebinars!: WebinarShipment[] | undefined;
    shippedWebinars!: WebinarShipment[] | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nonShippedWebinars"])) {
                this.nonShippedWebinars = [] as any;
                for (let item of _data["nonShippedWebinars"])
                    this.nonShippedWebinars!.push(WebinarShipment.fromJS(item));
            }
            if (Array.isArray(_data["shippedWebinars"])) {
                this.shippedWebinars = [] as any;
                for (let item of _data["shippedWebinars"])
                    this.shippedWebinars!.push(WebinarShipment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyShipmentsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MyShipmentsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nonShippedWebinars)) {
            data["nonShippedWebinars"] = [];
            for (let item of this.nonShippedWebinars)
                data["nonShippedWebinars"].push(item.toJSON());
        }
        if (Array.isArray(this.shippedWebinars)) {
            data["shippedWebinars"] = [];
            for (let item of this.shippedWebinars)
                data["shippedWebinars"].push(item.toJSON());
        }
        return data;
    }
}

export class MyStats {
    timeSpan!: string | undefined;
    slotsData!: Slots[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.timeSpan = _data["timeSpan"];
            if (Array.isArray(_data["slotsData"])) {
                this.slotsData = [] as any;
                for (let item of _data["slotsData"])
                    this.slotsData!.push(Slots.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyStats {
        data = typeof data === 'object' ? data : {};
        let result = new MyStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSpan"] = this.timeSpan;
        if (Array.isArray(this.slotsData)) {
            data["slotsData"] = [];
            for (let item of this.slotsData)
                data["slotsData"].push(item.toJSON());
        }
        return data;
    }
}

export class OnlineRatingCompany {
    id!: number;
    name!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OnlineRatingCompany {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineRatingCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export class OrderDTO {
    isSaveCardDetails!: boolean;
    cardNumber!: string | undefined;
    cardExpiryMonth!: string | undefined;
    cardExpiryYear!: string | undefined;
    cardCvv!: string | undefined;
    cardHolderName!: string | undefined;
    userId!: number;
    orderItems!: OrderItemDTO[] | undefined;
    useWallet!: boolean;
    walletAmount!: number;

    init(_data?: any) {
        if (_data) {
            this.isSaveCardDetails = _data["isSaveCardDetails"];
            this.cardNumber = _data["cardNumber"];
            this.cardExpiryMonth = _data["cardExpiryMonth"];
            this.cardExpiryYear = _data["cardExpiryYear"];
            this.cardCvv = _data["cardCvv"];
            this.cardHolderName = _data["cardHolderName"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemDTO.fromJS(item));
            }
            this.useWallet = _data["useWallet"];
            this.walletAmount = _data["walletAmount"];
        }
    }

    static fromJS(data: any): OrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSaveCardDetails"] = this.isSaveCardDetails;
        data["cardNumber"] = this.cardNumber;
        data["cardExpiryMonth"] = this.cardExpiryMonth;
        data["cardExpiryYear"] = this.cardExpiryYear;
        data["cardCvv"] = this.cardCvv;
        data["cardHolderName"] = this.cardHolderName;
        data["userId"] = this.userId;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["useWallet"] = this.useWallet;
        data["walletAmount"] = this.walletAmount;
        return data;
    }
}

export class OrderItemDTO {
    webinarId!: number;
    seatId!: number;
    cartId!: number;
    amount!: number;
    currency!: string | undefined;
    webinar!: Webinar;

    init(_data?: any) {
        if (_data) {
            this.webinarId = _data["webinarId"];
            this.seatId = _data["seatId"];
            this.cartId = _data["cartId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.webinar = _data["webinar"] ? Webinar.fromJS(_data["webinar"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webinarId"] = this.webinarId;
        data["seatId"] = this.seatId;
        data["cartId"] = this.cartId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["webinar"] = this.webinar ? this.webinar.toJSON() : <any>undefined;
        return data;
    }
}

export class OutOfOffice {
    id!: number;
    date!: Date;
    userId!: number;
    active!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): OutOfOffice {
        data = typeof data === 'object' ? data : {};
        let result = new OutOfOffice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["active"] = this.active;
        return data;
    }
}

export class PaymentDTO {
    paymentInfo!: PaymentInfo;
    cartDetail!: OrderItemDTO[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfo.fromJS(_data["paymentInfo"]) : <any>undefined;
            if (Array.isArray(_data["cartDetail"])) {
                this.cartDetail = [] as any;
                for (let item of _data["cartDetail"])
                    this.cartDetail!.push(OrderItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.cartDetail)) {
            data["cartDetail"] = [];
            for (let item of this.cartDetail)
                data["cartDetail"].push(item.toJSON());
        }
        return data;
    }
}

export class PaymentInfo {
    id!: number;
    transactionId!: string | undefined;
    paymentTime!: Date;
    amount!: number;
    currency!: string | undefined;
    invoiceNumber!: string | undefined;
    paymentMode!: string | undefined;
    comments!: string | undefined;
    paymentStatusId!: number;
    userId!: number;
    paymentStatusMaster!: PaymentStatusMaster;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionId = _data["transactionId"];
            this.paymentTime = _data["paymentTime"] ? new Date(_data["paymentTime"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.paymentMode = _data["paymentMode"];
            this.comments = _data["comments"];
            this.paymentStatusId = _data["paymentStatusId"];
            this.userId = _data["userId"];
            this.paymentStatusMaster = _data["paymentStatusMaster"] ? PaymentStatusMaster.fromJS(_data["paymentStatusMaster"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionId"] = this.transactionId;
        data["paymentTime"] = this.paymentTime ? this.paymentTime.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["invoiceNumber"] = this.invoiceNumber;
        data["paymentMode"] = this.paymentMode;
        data["comments"] = this.comments;
        data["paymentStatusId"] = this.paymentStatusId;
        data["userId"] = this.userId;
        data["paymentStatusMaster"] = this.paymentStatusMaster ? this.paymentStatusMaster.toJSON() : <any>undefined;
        return data;
    }
}

export class PaymentStatusMaster {
    id!: number;
    paymentStatus!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): PaymentStatusMaster {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentStatusMaster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export class Platform {
    name!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Platform {
        data = typeof data === 'object' ? data : {};
        let result = new Platform();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export class PlatformChargesGetDTO {
    user!: User;
    webinarRoom!: WebinarRoom;
    platformCharge!: RoomOwnerPlatformCharge;

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.webinarRoom = _data["webinarRoom"] ? WebinarRoom.fromJS(_data["webinarRoom"]) : <any>undefined;
            this.platformCharge = _data["platformCharge"] ? RoomOwnerPlatformCharge.fromJS(_data["platformCharge"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlatformChargesGetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformChargesGetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["webinarRoom"] = this.webinarRoom ? this.webinarRoom.toJSON() : <any>undefined;
        data["platformCharge"] = this.platformCharge ? this.platformCharge.toJSON() : <any>undefined;
        return data;
    }
}

export class Product {
    id!: number;
    productName!: string | undefined;
    description!: string | undefined;
    quantity!: number;
    price!: number;
    image!: string | undefined;
    active!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.image = _data["image"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["image"] = this.image;
        data["active"] = this.active;
        return data;
    }
}

export class PurchaseHistoryDTO {
    productReview!: string | undefined;
    seatPurchased!: number;
    totalPrice!: number | undefined;
    orderId!: string | undefined;
    roomName!: string | undefined;
    roomCurrentName!: string | undefined;
    createdDate!: Date | undefined;
    seatNumbers!: string | undefined;
    webinarVideopath!: string | undefined;
    videorecordingPath!: string | undefined;
    isWebinarCompleted!: boolean;
    imageUrl!: string | undefined;
    webinarId!: number;

    init(_data?: any) {
        if (_data) {
            this.productReview = _data["productReview"];
            this.seatPurchased = _data["seatPurchased"];
            this.totalPrice = _data["totalPrice"];
            this.orderId = _data["orderId"];
            this.roomName = _data["roomName"];
            this.roomCurrentName = _data["roomCurrentName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.seatNumbers = _data["seatNumbers"];
            this.webinarVideopath = _data["webinarVideopath"];
            this.videorecordingPath = _data["videorecordingPath"];
            this.isWebinarCompleted = _data["isWebinarCompleted"];
            this.imageUrl = _data["imageUrl"];
            this.webinarId = _data["webinarId"];
        }
    }

    static fromJS(data: any): PurchaseHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productReview"] = this.productReview;
        data["seatPurchased"] = this.seatPurchased;
        data["totalPrice"] = this.totalPrice;
        data["orderId"] = this.orderId;
        data["roomName"] = this.roomName;
        data["roomCurrentName"] = this.roomCurrentName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["seatNumbers"] = this.seatNumbers;
        data["webinarVideopath"] = this.webinarVideopath;
        data["videorecordingPath"] = this.videorecordingPath;
        data["isWebinarCompleted"] = this.isWebinarCompleted;
        data["imageUrl"] = this.imageUrl;
        data["webinarId"] = this.webinarId;
        return data;
    }
}

export class PurchaseHistoryDTOPagedResult {
    data!: PurchaseHistoryDTO[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PurchaseHistoryDTO.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PurchaseHistoryDTOPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseHistoryDTOPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export class PurchaseHistoryRevenueDTO {
    webinarId!: number | undefined;
    roomName!: string | undefined;
    seatId!: number | undefined;
    transactionId!: string | undefined;
    price!: number | undefined;
    userId!: number;
    createdDate!: Date;
    orderId!: string | undefined;
    paymentId!: number;
    currency!: string | undefined;
    orderDate!: Date;
    totalSeats!: number;

    init(_data?: any) {
        if (_data) {
            this.webinarId = _data["webinarId"];
            this.roomName = _data["roomName"];
            this.seatId = _data["seatId"];
            this.transactionId = _data["transactionId"];
            this.price = _data["price"];
            this.userId = _data["userId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
            this.paymentId = _data["paymentId"];
            this.currency = _data["currency"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.totalSeats = _data["totalSeats"];
        }
    }

    static fromJS(data: any): PurchaseHistoryRevenueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseHistoryRevenueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webinarId"] = this.webinarId;
        data["roomName"] = this.roomName;
        data["seatId"] = this.seatId;
        data["transactionId"] = this.transactionId;
        data["price"] = this.price;
        data["userId"] = this.userId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        data["paymentId"] = this.paymentId;
        data["currency"] = this.currency;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["totalSeats"] = this.totalSeats;
        return data;
    }
}

export class RefundPaymentInfo {
    id!: number;
    transactionId!: string;
    paymentTime!: Date;
    refundAmount!: number;
    currency!: string;
    refundMode!: string | undefined;
    comments!: string | undefined;
    refundPaymentStatusId!: number;
    paymentInfoId!: number;
    userId!: number;
    webinarIds!: string | undefined;
    orderItemsJson!: string | undefined;
    paymentStatusMaster!: PaymentStatusMaster;
    paymentInfo!: PaymentInfo;
    user!: User;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionId = _data["transactionId"];
            this.paymentTime = _data["paymentTime"] ? new Date(_data["paymentTime"].toString()) : <any>undefined;
            this.refundAmount = _data["refundAmount"];
            this.currency = _data["currency"];
            this.refundMode = _data["refundMode"];
            this.comments = _data["comments"];
            this.refundPaymentStatusId = _data["refundPaymentStatusId"];
            this.paymentInfoId = _data["paymentInfoId"];
            this.userId = _data["userId"];
            this.webinarIds = _data["webinarIds"];
            this.orderItemsJson = _data["orderItemsJson"];
            this.paymentStatusMaster = _data["paymentStatusMaster"] ? PaymentStatusMaster.fromJS(_data["paymentStatusMaster"]) : <any>undefined;
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfo.fromJS(_data["paymentInfo"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RefundPaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RefundPaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionId"] = this.transactionId;
        data["paymentTime"] = this.paymentTime ? this.paymentTime.toISOString() : <any>undefined;
        data["refundAmount"] = this.refundAmount;
        data["currency"] = this.currency;
        data["refundMode"] = this.refundMode;
        data["comments"] = this.comments;
        data["refundPaymentStatusId"] = this.refundPaymentStatusId;
        data["paymentInfoId"] = this.paymentInfoId;
        data["userId"] = this.userId;
        data["webinarIds"] = this.webinarIds;
        data["orderItemsJson"] = this.orderItemsJson;
        data["paymentStatusMaster"] = this.paymentStatusMaster ? this.paymentStatusMaster.toJSON() : <any>undefined;
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export class ResponseDTO {
    message!: string | undefined;
    status!: boolean | undefined;

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }
}

export class Role {
    id!: number;
    roleName!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        return data;
    }
}

export class RoomOwnerAccountDetail {
    accountId!: number;
    webinarRoomOwnerId!: number;
    accountNumber!: number;
    nameOnAccount!: string;
    routingNumber!: number;
    streetAddress!: string;
    city!: string;
    state!: string;
    zipCode!: string;
    isActive!: boolean;
    isUpdateAllowed!: boolean;
    createdAt!: Date;
    createdById!: number;
    updatedAt!: Date;
    updatedById!: number;

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.webinarRoomOwnerId = _data["webinarRoomOwnerId"];
            this.accountNumber = _data["accountNumber"];
            this.nameOnAccount = _data["nameOnAccount"];
            this.routingNumber = _data["routingNumber"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.isActive = _data["isActive"];
            this.isUpdateAllowed = _data["isUpdateAllowed"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedById = _data["updatedById"];
        }
    }

    static fromJS(data: any): RoomOwnerAccountDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RoomOwnerAccountDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["webinarRoomOwnerId"] = this.webinarRoomOwnerId;
        data["accountNumber"] = this.accountNumber;
        data["nameOnAccount"] = this.nameOnAccount;
        data["routingNumber"] = this.routingNumber;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["isActive"] = this.isActive;
        data["isUpdateAllowed"] = this.isUpdateAllowed;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedById"] = this.updatedById;
        return data;
    }
}

export class RoomOwnerPlatformCharge {
    platformChargesId!: number;
    webinarRoomOwnerId!: number;
    webinarRoomOwner!: WebinarRoomOwner;
    percentage!: number;

    init(_data?: any) {
        if (_data) {
            this.platformChargesId = _data["platformChargesId"];
            this.webinarRoomOwnerId = _data["webinarRoomOwnerId"];
            this.webinarRoomOwner = _data["webinarRoomOwner"] ? WebinarRoomOwner.fromJS(_data["webinarRoomOwner"]) : <any>undefined;
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): RoomOwnerPlatformCharge {
        data = typeof data === 'object' ? data : {};
        let result = new RoomOwnerPlatformCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformChargesId"] = this.platformChargesId;
        data["webinarRoomOwnerId"] = this.webinarRoomOwnerId;
        data["webinarRoomOwner"] = this.webinarRoomOwner ? this.webinarRoomOwner.toJSON() : <any>undefined;
        data["percentage"] = this.percentage;
        return data;
    }
}

export class RoomWiseRevenueDTO {
    revenue!: number;
    dateFrom!: Date;
    dateTo!: Date;
    purchaseHistory!: PurchaseHistoryRevenueDTO[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.revenue = _data["revenue"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["purchaseHistory"])) {
                this.purchaseHistory = [] as any;
                for (let item of _data["purchaseHistory"])
                    this.purchaseHistory!.push(PurchaseHistoryRevenueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoomWiseRevenueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoomWiseRevenueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revenue"] = this.revenue;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        if (Array.isArray(this.purchaseHistory)) {
            data["purchaseHistory"] = [];
            for (let item of this.purchaseHistory)
                data["purchaseHistory"].push(item.toJSON());
        }
        return data;
    }
}

export class SeatPurchaseInfo {
    seatId!: number;
    seatNumber!: number;
    seatOwner!: string | undefined;
    purchaseDate!: Date | undefined;
    isSelected!: boolean;
    cost!: number | undefined;
    userId!: number | undefined;
    email!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.seatId = _data["seatId"];
            this.seatNumber = _data["seatNumber"];
            this.seatOwner = _data["seatOwner"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.isSelected = _data["isSelected"];
            this.cost = _data["cost"];
            this.userId = _data["userId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SeatPurchaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SeatPurchaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seatId"] = this.seatId;
        data["seatNumber"] = this.seatNumber;
        data["seatOwner"] = this.seatOwner;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["isSelected"] = this.isSelected;
        data["cost"] = this.cost;
        data["userId"] = this.userId;
        data["email"] = this.email;
        return data;
    }
}

export class SeatStatus {
    seatStatusId!: number;
    seatStatusName!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.seatStatusId = _data["seatStatusId"];
            this.seatStatusName = _data["seatStatusName"];
        }
    }

    static fromJS(data: any): SeatStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SeatStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seatStatusId"] = this.seatStatusId;
        data["seatStatusName"] = this.seatStatusName;
        return data;
    }
}

export class ShipmentUpdateDTO {
    shippingId!: number;
    shippingOptionId!: number;
    trackingId!: string | undefined;
    shippingPrice!: number;
    shippedOn!: Date;

    init(_data?: any) {
        if (_data) {
            this.shippingId = _data["shippingId"];
            this.shippingOptionId = _data["shippingOptionId"];
            this.trackingId = _data["trackingId"];
            this.shippingPrice = _data["shippingPrice"];
            this.shippedOn = _data["shippedOn"] ? new Date(_data["shippedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ShipmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shippingId"] = this.shippingId;
        data["shippingOptionId"] = this.shippingOptionId;
        data["trackingId"] = this.trackingId;
        data["shippingPrice"] = this.shippingPrice;
        data["shippedOn"] = this.shippedOn ? this.shippedOn.toISOString() : <any>undefined;
        return data;
    }
}

export class ShippingAddress {
    id!: number;
    name!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    stateId!: number;
    zipCode!: number;
    userId!: number;
    purchaseId!: number;
    isActive!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zipCode = _data["zipCode"];
            this.userId = _data["userId"];
            this.purchaseId = _data["purchaseId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ShippingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zipCode"] = this.zipCode;
        data["userId"] = this.userId;
        data["purchaseId"] = this.purchaseId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export class ShippingOption {
    id!: number;
    name!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ShippingOption {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export class USPSAddress {
    name!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    phone!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): USPSAddress {
        data = typeof data === 'object' ? data : {};
        let result = new USPSAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["phone"] = this.phone;
        return data;
    }
}

export class USPSLabelRequest {
    fromAddress!: USPSAddress;
    toAddress!: USPSAddress;
    weight!: number;
    length!: number;
    width!: number;
    height!: number;
    serviceType!: string | undefined;
    labelFormat!: string | undefined;
    saveFromAddress!: boolean | undefined;
    webinarRoomId!: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.fromAddress = _data["fromAddress"] ? USPSAddress.fromJS(_data["fromAddress"]) : <any>undefined;
            this.toAddress = _data["toAddress"] ? USPSAddress.fromJS(_data["toAddress"]) : <any>undefined;
            this.weight = _data["weight"];
            this.length = _data["length"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.serviceType = _data["serviceType"];
            this.labelFormat = _data["labelFormat"];
            this.saveFromAddress = _data["saveFromAddress"];
            this.webinarRoomId = _data["webinarRoomId"];
        }
    }

    static fromJS(data: any): USPSLabelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new USPSLabelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromAddress"] = this.fromAddress ? this.fromAddress.toJSON() : <any>undefined;
        data["toAddress"] = this.toAddress ? this.toAddress.toJSON() : <any>undefined;
        data["weight"] = this.weight;
        data["length"] = this.length;
        data["width"] = this.width;
        data["height"] = this.height;
        data["serviceType"] = this.serviceType;
        data["labelFormat"] = this.labelFormat;
        data["saveFromAddress"] = this.saveFromAddress;
        data["webinarRoomId"] = this.webinarRoomId;
        return data;
    }
}

export class WebinarRoomOwnerFromAddress {
    id!: number;
    webinarOwnerId!: number;
    name!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    phone!: string | undefined;
    createdDate!: Date;
    modifiedDate!: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webinarOwnerId = _data["webinarOwnerId"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.phone = _data["phone"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WebinarRoomOwnerFromAddress {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRoomOwnerFromAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webinarOwnerId"] = this.webinarOwnerId;
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["phone"] = this.phone;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export class USPSLabelResponse {
    trackingNumber!: string | undefined;
    labelUrl!: string | undefined;
    labelData!: string | undefined;
    labelFormat!: string | undefined;
    postageAmount!: number;
    shippingServicesFile!: string | undefined;
    success!: boolean;
    errorMessage!: string | undefined;
    estimatedPrice!: number | undefined;
    priceSKU!: string | undefined;
    priceDescription!: string | undefined;
    priceType!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.trackingNumber = _data["trackingNumber"];
            this.labelUrl = _data["labelUrl"];
            this.labelData = _data["labelData"];
            this.labelFormat = _data["labelFormat"];
            this.postageAmount = _data["postageAmount"];
            this.shippingServicesFile = _data["shippingServicesFile"];
            this.success = _data["success"] ?? _data["Success"];
            this.errorMessage = _data["errorMessage"] ?? _data["ErrorMessage"];
            this.estimatedPrice = _data["estimatedPrice"];
            this.priceSKU = _data["priceSKU"];
            this.priceDescription = _data["priceDescription"];
            this.priceType = _data["priceType"];
        }
    }

    static fromJS(data: any): USPSLabelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new USPSLabelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingNumber"] = this.trackingNumber;
        data["labelUrl"] = this.labelUrl;
        data["labelData"] = this.labelData;
        data["labelFormat"] = this.labelFormat;
        data["postageAmount"] = this.postageAmount;
        data["shippingServicesFile"] = this.shippingServicesFile;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["estimatedPrice"] = this.estimatedPrice;
        data["priceSKU"] = this.priceSKU;
        data["priceDescription"] = this.priceDescription;
        data["priceType"] = this.priceType;
        return data;
    }
}

export class USPSPriceResponse {
    success!: boolean;
    errorMessage!: string | undefined;
    totalBasePrice!: number | undefined;
    priceSKU!: string | undefined;
    priceDescription!: string | undefined;
    priceType!: string | undefined;
    mailClass!: string | undefined;
    zone!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.totalBasePrice = _data["totalBasePrice"];
            this.priceSKU = _data["priceSKU"];
            this.priceDescription = _data["priceDescription"];
            this.priceType = _data["priceType"];
            this.mailClass = _data["mailClass"];
            this.zone = _data["zone"];
        }
    }

    static fromJS(data: any): USPSPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new USPSPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["totalBasePrice"] = this.totalBasePrice;
        data["priceSKU"] = this.priceSKU;
        data["priceDescription"] = this.priceDescription;
        data["priceType"] = this.priceType;
        data["mailClass"] = this.mailClass;
        data["zone"] = this.zone;
        return data;
    }
}

export class USPSAddressValidationRequest {
    streetAddress!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    zipPlus4!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.zipPlus4 = _data["zipPlus4"];
        }
    }

    static fromJS(data: any): USPSAddressValidationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new USPSAddressValidationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["zipPlus4"] = this.zipPlus4;
        return data;
    }
}

export class USPSAddressValidationResponse {
    success!: boolean;
    isValid!: boolean;
    errorMessage!: string | undefined;
    validatedStreetAddress!: string | undefined;
    validatedCity!: string | undefined;
    validatedState!: string | undefined;
    validatedZipCode!: string | undefined;
    validatedZipPlus4!: string | undefined;
    dpvConfirmation!: string | undefined;
    dpvDescription!: string | undefined;
    addressQuality!: string | undefined;
    returnText!: string | undefined;
    suggestedStreetAddress!: string | undefined;
    suggestedCity!: string | undefined;
    suggestedState!: string | undefined;
    suggestedZipCode!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.isValid = _data["isValid"];
            this.errorMessage = _data["errorMessage"];
            this.validatedStreetAddress = _data["validatedStreetAddress"];
            this.validatedCity = _data["validatedCity"];
            this.validatedState = _data["validatedState"];
            this.validatedZipCode = _data["validatedZipCode"];
            this.validatedZipPlus4 = _data["validatedZipPlus4"];
            this.dpvConfirmation = _data["dpvConfirmation"];
            this.dpvDescription = _data["dpvDescription"];
            this.addressQuality = _data["addressQuality"];
            this.returnText = _data["returnText"];
            this.suggestedStreetAddress = _data["suggestedStreetAddress"];
            this.suggestedCity = _data["suggestedCity"];
            this.suggestedState = _data["suggestedState"];
            this.suggestedZipCode = _data["suggestedZipCode"];
        }
    }

    static fromJS(data: any): USPSAddressValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new USPSAddressValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["isValid"] = this.isValid;
        data["errorMessage"] = this.errorMessage;
        data["validatedStreetAddress"] = this.validatedStreetAddress;
        data["validatedCity"] = this.validatedCity;
        data["validatedState"] = this.validatedState;
        data["validatedZipCode"] = this.validatedZipCode;
        data["validatedZipPlus4"] = this.validatedZipPlus4;
        data["dpvConfirmation"] = this.dpvConfirmation;
        data["dpvDescription"] = this.dpvDescription;
        data["addressQuality"] = this.addressQuality;
        data["returnText"] = this.returnText;
        data["suggestedStreetAddress"] = this.suggestedStreetAddress;
        data["suggestedCity"] = this.suggestedCity;
        data["suggestedState"] = this.suggestedState;
        data["suggestedZipCode"] = this.suggestedZipCode;
        return data;
    }
}

export class SisterWebsite {
    id!: number;
    websiteName!: string | undefined;
    websiteUrl!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.websiteName = _data["websiteName"];
            this.websiteUrl = _data["websiteUrl"];
        }
    }

    static fromJS(data: any): SisterWebsite {
        data = typeof data === 'object' ? data : {};
        let result = new SisterWebsite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["websiteName"] = this.websiteName;
        data["websiteUrl"] = this.websiteUrl;
        return data;
    }
}

export class Slots {
    slot!: string | undefined;
    webinarCount!: number;

    init(_data?: any) {
        if (_data) {
            this.slot = _data["slot"];
            this.webinarCount = _data["webinarCount"];
        }
    }

    static fromJS(data: any): Slots {
        data = typeof data === 'object' ? data : {};
        let result = new Slots();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slot"] = this.slot;
        data["webinarCount"] = this.webinarCount;
        return data;
    }
}

export class StateList {
    id!: number;
    name!: string | undefined;
    stateCode!: string | undefined;
    isActive!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stateCode = _data["stateCode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StateList {
        data = typeof data === 'object' ? data : {};
        let result = new StateList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stateCode"] = this.stateCode;
        data["isActive"] = this.isActive;
        return data;
    }
}

export class SubscriberRange {
    id!: number;
    name!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SubscriberRange {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriberRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export class TimeSlot {
    id!: number;
    name!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): TimeSlot {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export class UsaePayQueryResponse {
    type!: string | undefined;
    key!: string | undefined;
    refnum!: string | undefined;
    created!: string | undefined;
    trantype_code!: string | undefined;
    trantype!: string | undefined;
    result_code!: string | undefined;
    result!: string | undefined;
    authcode!: string | undefined;
    status_code!: string | undefined;
    status!: string | undefined;
    creditcard!: CreditcardQuery;
    batch!: BatchQuery;
    amount!: string | undefined;
    amount_detail!: AmountDetailQuery;
    customer_email!: string | undefined;
    merchant_email!: any | undefined;
    source_name!: string | undefined;
    platform!: Platform;
    available_actions!: string[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.key = _data["key"];
            this.refnum = _data["refnum"];
            this.created = _data["created"];
            this.trantype_code = _data["trantype_code"];
            this.trantype = _data["trantype"];
            this.result_code = _data["result_code"];
            this.result = _data["result"];
            this.authcode = _data["authcode"];
            this.status_code = _data["status_code"];
            this.status = _data["status"];
            this.creditcard = _data["creditcard"] ? CreditcardQuery.fromJS(_data["creditcard"]) : <any>undefined;
            this.batch = _data["batch"] ? BatchQuery.fromJS(_data["batch"]) : <any>undefined;
            this.amount = _data["amount"];
            this.amount_detail = _data["amount_detail"] ? AmountDetailQuery.fromJS(_data["amount_detail"]) : <any>undefined;
            this.customer_email = _data["customer_email"];
            this.merchant_email = _data["merchant_email"];
            this.source_name = _data["source_name"];
            this.platform = _data["platform"] ? Platform.fromJS(_data["platform"]) : <any>undefined;
            if (Array.isArray(_data["available_actions"])) {
                this.available_actions = [] as any;
                for (let item of _data["available_actions"])
                    this.available_actions!.push(item);
            }
        }
    }

    static fromJS(data: any): UsaePayQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UsaePayQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["key"] = this.key;
        data["refnum"] = this.refnum;
        data["created"] = this.created;
        data["trantype_code"] = this.trantype_code;
        data["trantype"] = this.trantype;
        data["result_code"] = this.result_code;
        data["result"] = this.result;
        data["authcode"] = this.authcode;
        data["status_code"] = this.status_code;
        data["status"] = this.status;
        data["creditcard"] = this.creditcard ? this.creditcard.toJSON() : <any>undefined;
        data["batch"] = this.batch ? this.batch.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["amount_detail"] = this.amount_detail ? this.amount_detail.toJSON() : <any>undefined;
        data["customer_email"] = this.customer_email;
        data["merchant_email"] = this.merchant_email;
        data["source_name"] = this.source_name;
        data["platform"] = this.platform ? this.platform.toJSON() : <any>undefined;
        if (Array.isArray(this.available_actions)) {
            data["available_actions"] = [];
            for (let item of this.available_actions)
                data["available_actions"].push(item);
        }
        return data;
    }
}

export class User {
    id!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    roleId!: number;
    password!: string | undefined;
    active!: boolean;
    emailId!: string | undefined;
    isNotificationEnabled!: boolean;
    isHost!: boolean;
    isOwner!: boolean;
    token!: string | undefined;
    isEmailVerified!: boolean;
    role!: Role;
    userContactInfos!: UserContactInfo[] | undefined;
    userNotifications!: UserNotification[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.roleId = _data["roleId"];
            this.password = _data["password"];
            this.active = _data["active"];
            this.emailId = _data["emailId"];
            this.isNotificationEnabled = _data["isNotificationEnabled"];
            this.isHost = _data["isHost"];
            this.isOwner = _data["isOwner"];
            this.token = _data["token"];
            this.isEmailVerified = _data["isEmailVerified"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["userContactInfos"])) {
                this.userContactInfos = [] as any;
                for (let item of _data["userContactInfos"])
                    this.userContactInfos!.push(UserContactInfo.fromJS(item));
            }
            if (Array.isArray(_data["userNotifications"])) {
                this.userNotifications = [] as any;
                for (let item of _data["userNotifications"])
                    this.userNotifications!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["roleId"] = this.roleId;
        data["password"] = this.password;
        data["active"] = this.active;
        data["emailId"] = this.emailId;
        data["isNotificationEnabled"] = this.isNotificationEnabled;
        data["isHost"] = this.isHost;
        data["isOwner"] = this.isOwner;
        data["token"] = this.token;
        data["isEmailVerified"] = this.isEmailVerified;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.userContactInfos)) {
            data["userContactInfos"] = [];
            for (let item of this.userContactInfos)
                data["userContactInfos"].push(item.toJSON());
        }
        if (Array.isArray(this.userNotifications)) {
            data["userNotifications"] = [];
            for (let item of this.userNotifications)
                data["userNotifications"].push(item.toJSON());
        }
        return data;
    }
}

export class UserComDTO {
    emailId!: string | undefined;
    mobileNumber!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.emailId = _data["emailId"];
            this.mobileNumber = _data["mobileNumber"];
        }
    }

    static fromJS(data: any): UserComDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserComDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailId"] = this.emailId;
        data["mobileNumber"] = this.mobileNumber;
        return data;
    }
}

export class UserContactInfo {
    streetAddress!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    phoneNumber!: string | undefined;
    id!: number;
    userId!: number;
    countryCode!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UserContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["phoneNumber"] = this.phoneNumber;
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export class UserNotification {
    id!: number;
    userId!: number;
    isPhone!: boolean;
    isEmail!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.isPhone = _data["isPhone"];
            this.isEmail = _data["isEmail"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["isPhone"] = this.isPhone;
        data["isEmail"] = this.isEmail;
        return data;
    }
}

export class UserSeat {
    seatId!: number;
    seatNumber!: number;
    userName!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.seatId = _data["seatId"];
            this.seatNumber = _data["seatNumber"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): UserSeat {
        data = typeof data === 'object' ? data : {};
        let result = new UserSeat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seatId"] = this.seatId;
        data["seatNumber"] = this.seatNumber;
        data["userName"] = this.userName;
        return data;
    }
}

export class Wallet {
    id!: number;
    userId!: number;
    balance!: number;
    isActive!: boolean;
    createdBy!: number;
    modifiedBy!: number | undefined;
    createdDate!: Date;
    modifiedDate!: Date;
    user!: User;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.balance = _data["balance"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Wallet {
        data = typeof data === 'object' ? data : {};
        let result = new Wallet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["balance"] = this.balance;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export class WalletBalanceDTO {
    walletId!: number;
    userId!: number;
    balance!: number;
    userName!: string | undefined;
    userEmail!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.walletId = _data["walletId"];
            this.userId = _data["userId"];
            this.balance = _data["balance"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): WalletBalanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WalletBalanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletId"] = this.walletId;
        data["userId"] = this.userId;
        data["balance"] = this.balance;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export class WalletPaymentDTO {
    userId!: number;
    amount!: number;
    description!: string | undefined;
    paymentId!: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any): WalletPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WalletPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["paymentId"] = this.paymentId;
        return data;
    }
}

export class WalletTransaction {
    id!: number;
    walletId!: number;
    userId!: number;
    transactionType!: string | undefined;
    amount!: number;
    balanceBefore!: number;
    balanceAfter!: number;
    description!: string | undefined;
    referenceId!: number | undefined;
    referenceType!: string | undefined;
    isActive!: boolean;
    createdBy!: number;
    modifiedBy!: number | undefined;
    createdDate!: Date;
    modifiedDate!: Date;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.walletId = _data["walletId"];
            this.userId = _data["userId"];
            this.transactionType = _data["transactionType"];
            this.amount = _data["amount"];
            this.balanceBefore = _data["balanceBefore"];
            this.balanceAfter = _data["balanceAfter"];
            this.description = _data["description"];
            this.referenceId = _data["referenceId"];
            this.referenceType = _data["referenceType"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WalletTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["walletId"] = this.walletId;
        data["userId"] = this.userId;
        data["transactionType"] = this.transactionType;
        data["amount"] = this.amount;
        data["balanceBefore"] = this.balanceBefore;
        data["balanceAfter"] = this.balanceAfter;
        data["description"] = this.description;
        data["referenceId"] = this.referenceId;
        data["referenceType"] = this.referenceType;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export class WeatherForecast {
    date!: Date;
    temperatureC!: number;
    readonly temperatureF!: number;
    summary!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.temperatureC = _data["temperatureC"];
            (<any>this).temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data;
    }
}

export class RecentWinnerDTO {
    displayName!: string | undefined;
    initial!: string | undefined;
    prizeName!: string | undefined;
    imageUrl!: string | undefined;
    wonOn!: Date;

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.initial = _data["initial"];
            this.prizeName = _data["prizeName"];
            this.imageUrl = _data["imageUrl"];
            this.wonOn = _data["wonOn"] ? new Date(_data["wonOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentWinnerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecentWinnerDTO();
        result.init(data);
        return result;
    }
}

export class Webinar {
    errors!: string[] | undefined;
    name!: string | undefined;
    image!: string | undefined;
    imageUrl!: string | undefined;
    numberOfSeats!: number;
    pricePerSeat!: number;
    grossProjectedSale!: number;
    purchaseCost!: number;
    shippingCost!: number | undefined;
    description!: string | undefined;
    createdBy!: number;
    modifiedBy!: number;
    createdDate!: Date;
    modifiedDate!: Date;
    startDateTime!: Date;
    closeDateTime!: Date | undefined;
    webinarId!: number;
    roomId!: number;
    ownerId!: number;
    webinarNumber!: string | undefined;
    createdByName!: string | undefined;
    modifiedByName!: string | undefined;
    timeSlotId!: number;
    videoLengthInSec!: number;
    statusId!: number;
    isAccountSettled!: boolean | undefined;
    maxSeatsAllowedPerUser!: number | undefined;
    seatsLeft!: number;
    isFreeBee!: boolean;
    durationInMinutes!: number | undefined;
    webinarImages!: WebinarImage[] | undefined;
    webinarSeats!: WebinarSeat[] | undefined;
    webinarReviews!: WebinarReview[] | undefined;
    owner!: WebinarRoomOwner;
    room!: WebinarRoom;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.name = _data["name"];
            this.image = _data["image"];
            this.imageUrl = _data["imageUrl"];
            this.numberOfSeats = _data["numberOfSeats"];
            this.pricePerSeat = _data["pricePerSeat"];
            this.grossProjectedSale = _data["grossProjectedSale"];
            this.purchaseCost = _data["purchaseCost"];
            this.shippingCost = _data["shippingCost"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.closeDateTime = _data["closeDateTime"] ? new Date(_data["closeDateTime"].toString()) : <any>undefined;
            this.webinarId = _data["webinarId"];
            this.roomId = _data["roomId"];
            this.ownerId = _data["ownerId"];
            this.webinarNumber = _data["webinarNumber"];
            this.createdByName = _data["createdByName"];
            this.modifiedByName = _data["modifiedByName"];
            this.timeSlotId = _data["timeSlotId"];
            this.videoLengthInSec = _data["videoLengthInSec"];
            this.statusId = _data["statusId"];
            this.isAccountSettled = _data["isAccountSettled"];
            this.maxSeatsAllowedPerUser = _data["maxSeatsAllowedPerUser"];
            this.seatsLeft = _data["seatsLeft"];
            this.isFreeBee = _data["isFreeBee"];
            this.durationInMinutes = _data["durationInMinutes"];
            if (Array.isArray(_data["webinarImages"])) {
                this.webinarImages = [] as any;
                for (let item of _data["webinarImages"])
                    this.webinarImages!.push(WebinarImage.fromJS(item));
            }
            if (Array.isArray(_data["webinarSeats"])) {
                this.webinarSeats = [] as any;
                for (let item of _data["webinarSeats"])
                    this.webinarSeats!.push(WebinarSeat.fromJS(item));
            }
            if (Array.isArray(_data["webinarReviews"])) {
                this.webinarReviews = [] as any;
                for (let item of _data["webinarReviews"])
                    this.webinarReviews!.push(WebinarReview.fromJS(item));
            }
            this.owner = _data["owner"] ? WebinarRoomOwner.fromJS(_data["owner"]) : <any>undefined;
            this.room = _data["room"] ? WebinarRoom.fromJS(_data["room"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Webinar {
        data = typeof data === 'object' ? data : {};
        let result = new Webinar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["name"] = this.name;
        data["image"] = this.image;
        data["imageUrl"] = this.imageUrl;
        data["numberOfSeats"] = this.numberOfSeats;
        data["pricePerSeat"] = this.pricePerSeat;
        data["grossProjectedSale"] = this.grossProjectedSale;
        data["purchaseCost"] = this.purchaseCost;
        data["shippingCost"] = this.shippingCost;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["closeDateTime"] = this.closeDateTime ? this.closeDateTime.toISOString() : <any>undefined;
        data["webinarId"] = this.webinarId;
        data["roomId"] = this.roomId;
        data["ownerId"] = this.ownerId;
        data["webinarNumber"] = this.webinarNumber;
        data["createdByName"] = this.createdByName;
        data["modifiedByName"] = this.modifiedByName;
        data["timeSlotId"] = this.timeSlotId;
        data["videoLengthInSec"] = this.videoLengthInSec;
        data["statusId"] = this.statusId;
        data["isAccountSettled"] = this.isAccountSettled;
        data["maxSeatsAllowedPerUser"] = this.maxSeatsAllowedPerUser;
        data["seatsLeft"] = this.seatsLeft;
        data["isFreeBee"] = this.isFreeBee;
        data["durationInMinutes"] = this.durationInMinutes;
        if (Array.isArray(this.webinarImages)) {
            data["webinarImages"] = [];
            for (let item of this.webinarImages)
                data["webinarImages"].push(item.toJSON());
        }
        if (Array.isArray(this.webinarSeats)) {
            data["webinarSeats"] = [];
            for (let item of this.webinarSeats)
                data["webinarSeats"].push(item.toJSON());
        }
        if (Array.isArray(this.webinarReviews)) {
            data["webinarReviews"] = [];
            for (let item of this.webinarReviews)
                data["webinarReviews"].push(item.toJSON());
        }
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["room"] = this.room ? this.room.toJSON() : <any>undefined;
        return data;
    }
}

export class WebinarFreeWinningDTO {
    image!: string | undefined;
    imageUrl!: string | undefined;
    webinarId!: number;
    description!: string | undefined;
    name!: string | undefined;
    seatNumber!: number | undefined;
    orderId!: string | undefined;
    orderDate!: Date | undefined;
    isFreeBee!: boolean;
    shippingStatus!: string | undefined;
    trackingNumber!: string | undefined;
    carrierName!: string | undefined;
    shippedOn!: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.imageUrl = _data["imageUrl"];
            this.webinarId = _data["webinarId"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.seatNumber = _data["seatNumber"];
            this.orderId = _data["orderId"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.isFreeBee = _data["isFreeBee"];
            this.shippingStatus = _data["shippingStatus"];
            this.trackingNumber = _data["trackingNumber"];
            this.carrierName = _data["carrierName"];
            this.shippedOn = _data["shippedOn"] ? new Date(_data["shippedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WebinarFreeWinningDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarFreeWinningDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["imageUrl"] = this.imageUrl;
        data["webinarId"] = this.webinarId;
        data["description"] = this.description;
        data["name"] = this.name;
        data["seatNumber"] = this.seatNumber;
        data["orderId"] = this.orderId;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["isFreeBee"] = this.isFreeBee;
        data["shippingStatus"] = this.shippingStatus;
        data["trackingNumber"] = this.trackingNumber;
        data["carrierName"] = this.carrierName;
        data["shippedOn"] = this.shippedOn ? this.shippedOn.toISOString() : <any>undefined;
        return data;
    }
}

export class WebinarFreeWinningDTOPagedResult {
    data!: WebinarFreeWinningDTO[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WebinarFreeWinningDTO.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): WebinarFreeWinningDTOPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarFreeWinningDTOPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export class WebinarImage {
    webinarId!: number;
    webinarImageId!: number;
    image!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.webinarId = _data["webinarId"];
            this.webinarImageId = _data["webinarImageId"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): WebinarImage {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webinarId"] = this.webinarId;
        data["webinarImageId"] = this.webinarImageId;
        data["image"] = this.image;
        return data;
    }
}

export class WebinarQueue {
    image!: string | undefined;
    webinarId!: number;
    videoLength!: string | undefined;
    description!: string | undefined;
    timeSlot!: string | undefined;
    itemsInTimeSlot!: number;
    itemsSuggested!: number;
    isPosted!: boolean;
    webinarName!: string | undefined;
    currentRoomName!: string | undefined;
    roomName!: string | undefined;
    totalSeats!: number;
    availableSeats!: number;

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.webinarId = _data["webinarId"];
            this.videoLength = _data["videoLength"];
            this.description = _data["description"];
            this.timeSlot = _data["timeSlot"];
            this.itemsInTimeSlot = _data["itemsInTimeSlot"];
            this.itemsSuggested = _data["itemsSuggested"];
            this.isPosted = _data["isPosted"];
            this.webinarName = _data["webinarName"];
            this.currentRoomName = _data["currentRoomName"];
            this.roomName = _data["roomName"];
            this.totalSeats = _data["totalSeats"];
            this.availableSeats = _data["availableSeats"];
        }
    }

    static fromJS(data: any): WebinarQueue {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["webinarId"] = this.webinarId;
        data["videoLength"] = this.videoLength;
        data["description"] = this.description;
        data["timeSlot"] = this.timeSlot;
        data["itemsInTimeSlot"] = this.itemsInTimeSlot;
        data["itemsSuggested"] = this.itemsSuggested;
        data["isPosted"] = this.isPosted;
        data["webinarName"] = this.webinarName;
        data["currentRoomName"] = this.currentRoomName;
        data["roomName"] = this.roomName;
        data["totalSeats"] = this.totalSeats;
        data["availableSeats"] = this.availableSeats;
        return data;
    }
}

export class WebinarQueueDTO {
    timeSlot!: string | undefined;
    timeSlotId!: number;
    webinarQueue!: WebinarQueue[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.timeSlot = _data["timeSlot"];
            this.timeSlotId = _data["timeSlotId"];
            if (Array.isArray(_data["webinarQueue"])) {
                this.webinarQueue = [] as any;
                for (let item of _data["webinarQueue"])
                    this.webinarQueue!.push(WebinarQueue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebinarQueueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarQueueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSlot"] = this.timeSlot;
        data["timeSlotId"] = this.timeSlotId;
        if (Array.isArray(this.webinarQueue)) {
            data["webinarQueue"] = [];
            for (let item of this.webinarQueue)
                data["webinarQueue"].push(item.toJSON());
        }
        return data;
    }
}

export class WebinarReview {
    id!: number;
    reviewComment!: string | undefined;
    reviewerEmailId!: string | undefined;
    reviewDate!: Date;
    reviewerName!: string | undefined;
    webinarId!: number;
    isDeleted!: boolean;
    deletedOn!: Date | undefined;
    webinarReviewHelpScores!: WebinarReviewHelpScore[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reviewComment = _data["reviewComment"];
            this.reviewerEmailId = _data["reviewerEmailId"];
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : <any>undefined;
            this.reviewerName = _data["reviewerName"];
            this.webinarId = _data["webinarId"];
            this.isDeleted = _data["isDeleted"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["webinarReviewHelpScores"])) {
                this.webinarReviewHelpScores = [] as any;
                for (let item of _data["webinarReviewHelpScores"])
                    this.webinarReviewHelpScores!.push(WebinarReviewHelpScore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebinarReview {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reviewComment"] = this.reviewComment;
        data["reviewerEmailId"] = this.reviewerEmailId;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : <any>undefined;
        data["reviewerName"] = this.reviewerName;
        data["webinarId"] = this.webinarId;
        data["isDeleted"] = this.isDeleted;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.webinarReviewHelpScores)) {
            data["webinarReviewHelpScores"] = [];
            for (let item of this.webinarReviewHelpScores)
                data["webinarReviewHelpScores"].push(item.toJSON());
        }
        return data;
    }
}

export class WebinarReviewHelpScore {
    id!: number;
    byEmail!: string;
    scoreOn!: Date;
    isHelpful!: boolean;
    reviewId!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.byEmail = _data["byEmail"];
            this.scoreOn = _data["scoreOn"] ? new Date(_data["scoreOn"].toString()) : <any>undefined;
            this.isHelpful = _data["isHelpful"];
            this.reviewId = _data["reviewId"];
        }
    }

    static fromJS(data: any): WebinarReviewHelpScore {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarReviewHelpScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["byEmail"] = this.byEmail;
        data["scoreOn"] = this.scoreOn ? this.scoreOn.toISOString() : <any>undefined;
        data["isHelpful"] = this.isHelpful;
        data["reviewId"] = this.reviewId;
        return data;
    }
}

export class WebinarRoom {
    roomId!: number;
    roomName!: string | undefined;
    image!: string | undefined;
    imageUrl!: string | undefined;
    active!: boolean;
    sortOrder!: number;
    description!: string | undefined;
    webinarRoomOwners!: WebinarRoomOwner[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.roomId = _data["roomId"];
            this.roomName = _data["roomName"];
            this.image = _data["image"];
            this.imageUrl = _data["imageUrl"];
            this.active = _data["active"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
            if (Array.isArray(_data["webinarRoomOwners"])) {
                this.webinarRoomOwners = [] as any;
                for (let item of _data["webinarRoomOwners"])
                    this.webinarRoomOwners!.push(WebinarRoomOwner.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebinarRoom {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomId"] = this.roomId;
        data["roomName"] = this.roomName;
        data["image"] = this.image;
        data["imageUrl"] = this.imageUrl;
        data["active"] = this.active;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        if (Array.isArray(this.webinarRoomOwners)) {
            data["webinarRoomOwners"] = [];
            for (let item of this.webinarRoomOwners)
                data["webinarRoomOwners"].push(item.toJSON());
        }
        return data;
    }
}

export class WebinarRoomConfiguration {
    id!: number;
    timeSlot!: string | undefined;
    webinarRoomId!: number;
    timeSlotId!: number;
    maxItems!: number;
    roomImage!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeSlot = _data["timeSlot"];
            this.webinarRoomId = _data["webinarRoomId"];
            this.timeSlotId = _data["timeSlotId"];
            this.maxItems = _data["maxItems"];
            this.roomImage = _data["roomImage"];
        }
    }

    static fromJS(data: any): WebinarRoomConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRoomConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeSlot"] = this.timeSlot;
        data["webinarRoomId"] = this.webinarRoomId;
        data["timeSlotId"] = this.timeSlotId;
        data["maxItems"] = this.maxItems;
        data["roomImage"] = this.roomImage;
        return data;
    }
}

export class WebinarRoomDTO {
    roomId!: number;
    roomName!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.roomId = _data["roomId"];
            this.roomName = _data["roomName"];
        }
    }

    static fromJS(data: any): WebinarRoomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRoomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomId"] = this.roomId;
        data["roomName"] = this.roomName;
        return data;
    }
}

export class WebinarRoomFFLImage {
    id!: number;
    webinarRoomOwnerId!: number;
    imagePath!: string | undefined;
    fileType!: string | undefined;
    onwerName!: string | undefined;
    roomName!: string | undefined;
    expiryDate!: Date | undefined;
    image!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webinarRoomOwnerId = _data["webinarRoomOwnerId"];
            this.imagePath = _data["imagePath"];
            this.fileType = _data["fileType"];
            this.onwerName = _data["onwerName"];
            this.roomName = _data["roomName"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): WebinarRoomFFLImage {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRoomFFLImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webinarRoomOwnerId"] = this.webinarRoomOwnerId;
        data["imagePath"] = this.imagePath;
        data["fileType"] = this.fileType;
        data["onwerName"] = this.onwerName;
        data["roomName"] = this.roomName;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["image"] = this.image;
        return data;
    }
}

export class WebinarRoomOwner {
    webinarOwnerId!: number;
    userId!: number;
    webinarRoomId!: number;
    active!: boolean;
    facebook_App_Id!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.webinarOwnerId = _data["webinarOwnerId"];
            this.userId = _data["userId"];
            this.webinarRoomId = _data["webinarRoomId"];
            this.active = _data["active"];
            this.facebook_App_Id = _data["facebook_App_Id"];
        }
    }

    static fromJS(data: any): WebinarRoomOwner {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRoomOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webinarOwnerId"] = this.webinarOwnerId;
        data["userId"] = this.userId;
        data["webinarRoomId"] = this.webinarRoomId;
        data["active"] = this.active;
        data["facebook_App_Id"] = this.facebook_App_Id;
        return data;
    }
}

export class WebinarRoomOwnerDTO {
    userId!: number;
    webinarRoomId!: number;
    roomName!: string | undefined;
    roomOwnerId!: number;
    roomDescription!: string | undefined;
    facebook_App_Id!: string | undefined;
    isWebinarRoomOwnserAssignmentActive!: boolean;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.webinarRoomId = _data["webinarRoomId"];
            this.roomName = _data["roomName"];
            this.roomOwnerId = _data["roomOwnerId"];
            this.roomDescription = _data["roomDescription"];
            this.facebook_App_Id = _data["facebook_App_Id"];
            this.isWebinarRoomOwnserAssignmentActive = _data["isWebinarRoomOwnserAssignmentActive"];
        }
    }

    static fromJS(data: any): WebinarRoomOwnerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRoomOwnerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["webinarRoomId"] = this.webinarRoomId;
        data["roomName"] = this.roomName;
        data["roomOwnerId"] = this.roomOwnerId;
        data["roomDescription"] = this.roomDescription;
        data["facebook_App_Id"] = this.facebook_App_Id;
        data["isWebinarRoomOwnserAssignmentActive"] = this.isWebinarRoomOwnserAssignmentActive;
        return data;
    }
}

export class WebinarRunDTO {
    status!: string | undefined;
    webinarStartDateTime!: Date;
    currentDateTime!: Date;
    selectedSeat!: number;
    fileExtention!: string | undefined;
    video!: string | undefined;
    userSeats!: UserSeat[] | undefined;
    secondsToStart!: number;
    firstDummyRunMin!: number | undefined;
    firstDummyRunMax!: number | undefined;
    secondDummyRunMax!: number | undefined;
    secondDummyRunMin!: number | undefined;
    thirdDummyRunMin!: number | undefined;
    thirdDummyRunMax!: number | undefined;
    seatsDisplayDelaySeconds!: number | undefined;
    itemImageUrl!: string | undefined;
    webinarName!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.webinarStartDateTime = _data["webinarStartDateTime"] ? new Date(_data["webinarStartDateTime"].toString()) : <any>undefined;
            this.currentDateTime = _data["currentDateTime"] ? new Date(_data["currentDateTime"].toString()) : <any>undefined;
            this.selectedSeat = _data["selectedSeat"];
            this.fileExtention = _data["fileExtention"];
            this.video = _data["video"];
            if (Array.isArray(_data["userSeats"])) {
                this.userSeats = [] as any;
                for (let item of _data["userSeats"])
                    this.userSeats!.push(UserSeat.fromJS(item));
            }
            this.secondsToStart = _data["secondsToStart"];
            this.firstDummyRunMin = _data["firstDummyRunMin"];
            this.firstDummyRunMax = _data["firstDummyRunMax"];
            this.secondDummyRunMax = _data["secondDummyRunMax"];
            this.secondDummyRunMin = _data["secondDummyRunMin"];
            this.thirdDummyRunMin = _data["thirdDummyRunMin"];
            this.thirdDummyRunMax = _data["thirdDummyRunMax"];
            this.seatsDisplayDelaySeconds = _data["seatsDisplayDelaySeconds"];
            this.itemImageUrl = _data["itemImageUrl"];
            this.webinarName = _data["webinarName"];
        }
    }

    static fromJS(data: any): WebinarRunDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRunDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["webinarStartDateTime"] = this.webinarStartDateTime ? this.webinarStartDateTime.toISOString() : <any>undefined;
        data["currentDateTime"] = this.currentDateTime ? this.currentDateTime.toISOString() : <any>undefined;
        data["selectedSeat"] = this.selectedSeat;
        data["fileExtention"] = this.fileExtention;
        data["video"] = this.video;
        if (Array.isArray(this.userSeats)) {
            data["userSeats"] = [];
            for (let item of this.userSeats)
                data["userSeats"].push(item.toJSON());
        }
        data["secondsToStart"] = this.secondsToStart;
        data["firstDummyRunMin"] = this.firstDummyRunMin;
        data["firstDummyRunMax"] = this.firstDummyRunMax;
        data["secondDummyRunMax"] = this.secondDummyRunMax;
        data["secondDummyRunMin"] = this.secondDummyRunMin;
        data["thirdDummyRunMin"] = this.thirdDummyRunMin;
        data["thirdDummyRunMax"] = this.thirdDummyRunMax;
        data["seatsDisplayDelaySeconds"] = this.seatsDisplayDelaySeconds;
        data["itemImageUrl"] = this.itemImageUrl;
        data["webinarName"] = this.webinarName;
        return data;
    }
}

export class WebinarRunningStatus {
    id!: number;
    name!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WebinarRunningStatus {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarRunningStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export class WebinarSeat {
    seatId!: number;
    webinarId!: number;
    seatNumber!: number;
    statusId!: number;
    selected!: boolean;
    status!: SeatStatus;

    init(_data?: any) {
        if (_data) {
            this.seatId = _data["seatId"];
            this.webinarId = _data["webinarId"];
            this.seatNumber = _data["seatNumber"];
            this.statusId = _data["statusId"];
            this.selected = _data["selected"];
            this.status = _data["status"] ? SeatStatus.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WebinarSeat {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarSeat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seatId"] = this.seatId;
        data["webinarId"] = this.webinarId;
        data["seatNumber"] = this.seatNumber;
        data["statusId"] = this.statusId;
        data["selected"] = this.selected;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export class WebinarSettlementDetail {
    settlementId!: number;
    webinarId!: number;
    webinarRoomOwnerId!: number;
    roomOwnerAccountDetailId!: number;
    platformChargesPercentage!: number;
    platformCharges!: number;
    settledAmount!: number;
    transactionNumber!: string;
    settledFromBank!: string;
    filePath!: string | undefined;
    image!: string | undefined;
    fileType!: string | undefined;
    settledOn!: Date;
    settledById!: number;
    webinar!: Webinar;

    init(_data?: any) {
        if (_data) {
            this.settlementId = _data["settlementId"];
            this.webinarId = _data["webinarId"];
            this.webinarRoomOwnerId = _data["webinarRoomOwnerId"];
            this.roomOwnerAccountDetailId = _data["roomOwnerAccountDetailId"];
            this.platformChargesPercentage = _data["platformChargesPercentage"];
            this.platformCharges = _data["platformCharges"];
            this.settledAmount = _data["settledAmount"];
            this.transactionNumber = _data["transactionNumber"];
            this.settledFromBank = _data["settledFromBank"];
            this.filePath = _data["filePath"];
            this.image = _data["image"];
            this.fileType = _data["fileType"];
            this.settledOn = _data["settledOn"] ? new Date(_data["settledOn"].toString()) : <any>undefined;
            this.settledById = _data["settledById"];
            this.webinar = _data["webinar"] ? Webinar.fromJS(_data["webinar"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WebinarSettlementDetail {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarSettlementDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settlementId"] = this.settlementId;
        data["webinarId"] = this.webinarId;
        data["webinarRoomOwnerId"] = this.webinarRoomOwnerId;
        data["roomOwnerAccountDetailId"] = this.roomOwnerAccountDetailId;
        data["platformChargesPercentage"] = this.platformChargesPercentage;
        data["platformCharges"] = this.platformCharges;
        data["settledAmount"] = this.settledAmount;
        data["transactionNumber"] = this.transactionNumber;
        data["settledFromBank"] = this.settledFromBank;
        data["filePath"] = this.filePath;
        data["image"] = this.image;
        data["fileType"] = this.fileType;
        data["settledOn"] = this.settledOn ? this.settledOn.toISOString() : <any>undefined;
        data["settledById"] = this.settledById;
        data["webinar"] = this.webinar ? this.webinar.toJSON() : <any>undefined;
        return data;
    }
}

export class WebinarSettlementDetailsForAllDto {
    roomName!: string | undefined;
    roomOwnerId!: number;
    alreadySettledAmount!: number;
    pendingForSettlement!: number;
    readyForSettlement!: number;
    readyNetSettlement!: number;
    details!: WebinarSettlementDetailsGetDTO[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.roomName = _data["roomName"];
            this.roomOwnerId = _data["roomOwnerId"];
            this.alreadySettledAmount = _data["alreadySettledAmount"];
            this.pendingForSettlement = _data["pendingForSettlement"];
            this.readyForSettlement = _data["readyForSettlement"];
            this.readyNetSettlement = _data["readyNetSettlement"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(WebinarSettlementDetailsGetDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebinarSettlementDetailsForAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarSettlementDetailsForAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomName"] = this.roomName;
        data["roomOwnerId"] = this.roomOwnerId;
        data["alreadySettledAmount"] = this.alreadySettledAmount;
        data["pendingForSettlement"] = this.pendingForSettlement;
        data["readyForSettlement"] = this.readyForSettlement;
        data["readyNetSettlement"] = this.readyNetSettlement;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export class WebinarSettlementDetailsGetDTO {
    roomId!: number;
    pendingForSettlement!: number;
    settledAmount!: number;
    readyForSettlement!: number;
    seatsRemainingToBeSold!: number;
    seatsSold!: number;
    platformChargesAmount!: number;
    toBeSettledAmountAfterPlatformChargesDeduction!: number;
    platformChargePercentage!: number;
    webinarName!: string | undefined;
    webinarId!: number;
    isWebinarSettlementAllowed!: boolean;
    shippingChargesAmount!: number;
    allSeatsSold!: boolean;
    webinarStatus!: string | undefined;
    settlementDisabledReason!: string | undefined;
    isShippingCompleted!: boolean;

    init(_data?: any) {
        if (_data) {
            this.roomId = _data["roomId"];
            this.pendingForSettlement = _data["pendingForSettlement"];
            this.settledAmount = _data["settledAmount"];
            this.readyForSettlement = _data["readyForSettlement"];
            this.seatsRemainingToBeSold = _data["seatsRemainingToBeSold"];
            this.seatsSold = _data["seatsSold"];
            this.platformChargesAmount = _data["platformChargesAmount"];
            this.toBeSettledAmountAfterPlatformChargesDeduction = _data["toBeSettledAmountAfterPlatformChargesDeduction"];
            this.platformChargePercentage = _data["platformChargePercentage"];
            this.webinarName = _data["webinarName"];
            this.webinarId = _data["webinarId"];
            this.isWebinarSettlementAllowed = _data["isWebinarSettlementAllowed"];
            this.shippingChargesAmount = _data["shippingChargesAmount"];
            this.allSeatsSold = _data["allSeatsSold"];
            this.webinarStatus = _data["webinarStatus"];
            this.settlementDisabledReason = _data["settlementDisabledReason"];
            this.isShippingCompleted = _data["isShippingCompleted"];
        }
    }

    static fromJS(data: any): WebinarSettlementDetailsGetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarSettlementDetailsGetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomId"] = this.roomId;
        data["pendingForSettlement"] = this.pendingForSettlement;
        data["settledAmount"] = this.settledAmount;
        data["readyForSettlement"] = this.readyForSettlement;
        data["seatsRemainingToBeSold"] = this.seatsRemainingToBeSold;
        data["seatsSold"] = this.seatsSold;
        data["platformChargesAmount"] = this.platformChargesAmount;
        data["toBeSettledAmountAfterPlatformChargesDeduction"] = this.toBeSettledAmountAfterPlatformChargesDeduction;
        data["platformChargePercentage"] = this.platformChargePercentage;
        data["webinarName"] = this.webinarName;
        data["webinarId"] = this.webinarId;
        data["isWebinarSettlementAllowed"] = this.isWebinarSettlementAllowed;
        data["shippingChargesAmount"] = this.shippingChargesAmount;
        data["allSeatsSold"] = this.allSeatsSold;
        data["webinarStatus"] = this.webinarStatus;
        data["settlementDisabledReason"] = this.settlementDisabledReason;
        data["isShippingCompleted"] = this.isShippingCompleted;
        return data;
    }
}

export class WebinarShipment {
    id!: number;
    webinar!: string | undefined;
    newOwner!: string | undefined;
    newOwnerEmail!: string | undefined;
    webinarEndDate!: Date;
    daysPassed!: number;
    shippingOptionId!: number | undefined;
    isNotified!: boolean;
    trackingId!: string | undefined;
    shippedOn!: Date | undefined;
    isEdit!: boolean;
    shippingPrice!: number | undefined;
    shippingOption!: ShippingOption;
    shipmentAddress!: WebinarShipmentAddress;
    // USPS fields
    uspsTrackingNumber!: string | undefined;
    uspsLabelUrl!: string | undefined;
    uspsLabelFormat!: string | undefined;
    uspsPostageAmount!: number | undefined;
    uspsServiceType!: string | undefined;
    packageWeight!: number | undefined;
    packageLength!: number | undefined;
    packageWidth!: number | undefined;
    packageHeight!: number | undefined;
    labelFormat!: string | undefined;
    // From Address fields (user entered)
    fromAddressName!: string | undefined;
    fromAddressStreet!: string | undefined;
    fromAddressCity!: string | undefined;
    fromAddressState!: string | undefined;
    fromAddressZipCode!: string | undefined;
    fromAddressPhone!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webinar = _data["webinar"];
            this.newOwner = _data["newOwner"];
            this.newOwnerEmail = _data["newOwnerEmail"];
            this.webinarEndDate = _data["webinarEndDate"] ? new Date(_data["webinarEndDate"].toString()) : <any>undefined;
            this.daysPassed = _data["daysPassed"];
            this.shippingOptionId = _data["shippingOptionId"];
            this.isNotified = _data["isNotified"];
            this.trackingId = _data["trackingId"];
            this.shippedOn = _data["shippedOn"] ? new Date(_data["shippedOn"].toString()) : <any>undefined;
            this.isEdit = _data["isEdit"];
            this.shippingPrice = _data["shippingPrice"];
            this.shippingOption = _data["shippingOption"] ? ShippingOption.fromJS(_data["shippingOption"]) : <any>undefined;
            this.shipmentAddress = _data["shipmentAddress"] ? WebinarShipmentAddress.fromJS(_data["shipmentAddress"]) : <any>undefined;
            this.uspsTrackingNumber = _data["uspsTrackingNumber"];
            this.uspsLabelUrl = _data["uspsLabelUrl"];
            this.uspsLabelFormat = _data["uspsLabelFormat"];
            this.uspsPostageAmount = _data["uspsPostageAmount"];
            this.uspsServiceType = _data["uspsServiceType"];
            this.packageWeight = _data["packageWeight"];
            this.packageLength = _data["packageLength"];
            this.packageWidth = _data["packageWidth"];
            this.packageHeight = _data["packageHeight"];
            this.labelFormat = _data["labelFormat"];
            this.fromAddressName = _data["fromAddressName"];
            this.fromAddressStreet = _data["fromAddressStreet"];
            this.fromAddressCity = _data["fromAddressCity"];
            this.fromAddressState = _data["fromAddressState"];
            this.fromAddressZipCode = _data["fromAddressZipCode"];
            this.fromAddressPhone = _data["fromAddressPhone"];
        }
    }

    static fromJS(data: any): WebinarShipment {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarShipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webinar"] = this.webinar;
        data["newOwner"] = this.newOwner;
        data["newOwnerEmail"] = this.newOwnerEmail;
        data["webinarEndDate"] = this.webinarEndDate ? this.webinarEndDate.toISOString() : <any>undefined;
        data["daysPassed"] = this.daysPassed;
        data["shippingOptionId"] = this.shippingOptionId;
        data["isNotified"] = this.isNotified;
        data["trackingId"] = this.trackingId;
        data["shippedOn"] = this.shippedOn ? this.shippedOn.toISOString() : <any>undefined;
        data["isEdit"] = this.isEdit;
        data["shippingPrice"] = this.shippingPrice;
        data["shippingOption"] = this.shippingOption ? this.shippingOption.toJSON() : <any>undefined;
        data["shipmentAddress"] = this.shipmentAddress ? this.shipmentAddress.toJSON() : <any>undefined;
        data["uspsTrackingNumber"] = this.uspsTrackingNumber;
        data["uspsLabelUrl"] = this.uspsLabelUrl;
        data["uspsLabelFormat"] = this.uspsLabelFormat;
        data["uspsPostageAmount"] = this.uspsPostageAmount;
        data["uspsServiceType"] = this.uspsServiceType;
        data["packageWeight"] = this.packageWeight;
        data["packageLength"] = this.packageLength;
        data["packageWidth"] = this.packageWidth;
        data["packageHeight"] = this.packageHeight;
        data["labelFormat"] = this.labelFormat;
        data["fromAddressName"] = this.fromAddressName;
        data["fromAddressStreet"] = this.fromAddressStreet;
        data["fromAddressCity"] = this.fromAddressCity;
        data["fromAddressState"] = this.fromAddressState;
        data["fromAddressZipCode"] = this.fromAddressZipCode;
        data["fromAddressPhone"] = this.fromAddressPhone;
        return data;
    }
}

export class WebinarShipmentAddress {
    id!: number;
    webinarShipmentId!: number;
    name!: string | undefined;
    city!: string | undefined;
    stateId!: number;
    zipCode!: string | undefined;
    street!: string | undefined;
    state!: StateList;
    phone!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webinarShipmentId = _data["webinarShipmentId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zipCode = _data["zipCode"];
            this.street = _data["street"];
            this.state = _data["state"] ? StateList.fromJS(_data["state"]) : <any>undefined;
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): WebinarShipmentAddress {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarShipmentAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webinarShipmentId"] = this.webinarShipmentId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zipCode"] = this.zipCode;
        data["street"] = this.street;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        return data;
    }
}

export class YearsIntoBusiness {
    id!: number;
    name!: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): YearsIntoBusiness {
        data = typeof data === 'object' ? data : {};
        let result = new YearsIntoBusiness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class apiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isapiException = true;

    static isapiException(obj: any): obj is apiException {
        return obj.isapiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new apiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}